/* ============================================
   FINEYST JACKETS - GLOBAL JAVASCRIPT
   ============================================ */

// Preload cart sidebar CSS to prevent loading issues
function preloadCartSidebarCSS() {
  const cartSidebarCSS = document.querySelector('link[href*="sections.css"]');
  if (cartSidebarCSS && !cartSidebarCSS.hasAttribute("data-preloaded")) {
    cartSidebarCSS.setAttribute("data-preloaded", "true");
    // Force CSS to be parsed by accessing a cart-related class
    const testElement = document.createElement("div");
    testElement.className = "cart-sidebar";
    testElement.style.position = "absolute";
    testElement.style.visibility = "hidden";
    testElement.style.top = "-9999px";
    document.body.appendChild(testElement);
    // Force reflow to ensure CSS is parsed
    testElement.offsetHeight;
    document.body.removeChild(testElement);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Preload cart sidebar CSS immediately
  preloadCartSidebarCSS();

  // Check if cart should be opened after page load
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("cart") === "open") {
    // Remove the parameter from URL
    urlParams.delete("cart");
    const newUrl =
      window.location.pathname +
      (urlParams.toString() ? "?" + urlParams.toString() : "");
    window.history.replaceState({}, "", newUrl);

    // Open cart sidebar after a short delay
    setTimeout(() => {
      openCartSidebar();
    }, 500);
  }

  // Initialize all components
  initHeader();
  initMobileMenu();
  initMegaMenu();
  initSearch();
  initProductGallery();
  initQuantityButtons();
  initAddToCart();
  initCartSidebar();
  initWishlist();
  initWelcomeCarousel();
  initHandPickedCarousel();
  initColorCollectionCarousel();
  initFAQ();
  initSectionCarousel();
  initNavigationOverlay();

  // Cart sidebar button handlers
  document.addEventListener("click", function (e) {
    const removeBtn = e.target.closest("[data-cart-remove]");
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();

      const key = removeBtn.dataset.cartRemove;
      const item = document.querySelector(`[data-cart-item-id="${key}"]`);

      if (item) {
        // Add smooth removal animation
        item.classList.add("removing");
        item.style.opacity = "0.5";
        item.style.pointerEvents = "none";
      }

      // Save scroll position before deletion
      const scrollable = document.querySelector("[data-cart-sidebar-items]");
      const scrollPosition = scrollable
        ? scrollable.parentElement.scrollTop
        : 0;

      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: 0 }),
      })
        .then((response) => response.json())
        .then((cart) => {
          // Wait for animation to complete before removing
          setTimeout(() => {
            if (item && item.parentElement) {
              item.remove();
            }
            if (typeof updateCartCount === "function") updateCartCount();
            if (typeof loadCartSidebar === "function") {
              loadCartSidebar();
              // Restore scroll position
              setTimeout(() => {
                const scrollableContainer = document.querySelector(
                  "[data-cart-sidebar]",
                );
                if (scrollableContainer) {
                  const scrollContainer = scrollableContainer.querySelector(
                    "[data-cart-sidebar-items]",
                  );
                  if (scrollContainer && scrollContainer.parentElement) {
                    scrollContainer.parentElement.scrollTop = Math.max(
                      0,
                      scrollPosition,
                    );
                  }
                }
              }, 50);
            }
          }, 300); // Match the animation duration in CSS
        })
        .catch((error) => {
          console.error("Error removing item:", error);
          if (item) {
            item.classList.remove("removing");
            item.style.opacity = "1";
            item.style.pointerEvents = "auto";
          }
        });
    }

    if (e.target.closest("[data-cart-quantity-decrease]")) {
      e.preventDefault();
      e.stopPropagation();
      const key = e.target.closest("[data-cart-quantity-decrease]").dataset
        .cartQuantityDecrease;
      const input = document.querySelector(
        `[data-cart-item-id="${key}"] [data-cart-quantity-input]`,
      );
      if (input && parseInt(input.value) > 1) {
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: key,
            quantity: parseInt(input.value) - 1,
          }),
        })
          .then((response) => response.json())
          .then((cart) => {
            if (typeof loadCartSidebar === "function") loadCartSidebar();
            if (typeof updateCartCount === "function") updateCartCount();
          });
      }
    }

    if (e.target.closest("[data-cart-quantity-increase]")) {
      e.preventDefault();
      e.stopPropagation();
      const key = e.target.closest("[data-cart-quantity-increase]").dataset
        .cartQuantityIncrease;
      const input = document.querySelector(
        `[data-cart-item-id="${key}"] [data-cart-quantity-input]`,
      );
      if (input) {
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: key,
            quantity: parseInt(input.value) + 1,
          }),
        })
          .then((response) => response.json())
          .then((cart) => {
            if (typeof loadCartSidebar === "function") loadCartSidebar();
            if (typeof updateCartCount === "function") updateCartCount();
          });
      }
    }
  });
});

/* Header Scroll Behavior */
function initHeader() {
  const header = document.querySelector("[data-header]");
  if (!header) return;

  // Force header to always be visible
  header.classList.remove("is-hidden");

  // Override any scroll behavior by forcing the header to stay visible
  const style = document.createElement("style");
  style.textContent = `
    .site-header.is-hidden {
      transform: translateY(0) !important;
    }
  `;
  document.head.appendChild(style);
}

/* Mobile Menu Toggle */
function initMobileMenu() {
  const menuToggle = document.querySelector("[data-menu-toggle]");
  const mobileMenu = document.querySelector("[data-mobile-menu]");
  const menuClose = document.querySelector("[data-menu-close]");
  const panels = mobileMenu
    ? mobileMenu.querySelectorAll("[data-menu-panel]")
    : [];
  let panelHistory = ["main"]; // Track panel navigation history

  if (!menuToggle || !mobileMenu) return;

  // Open mobile menu
  menuToggle.addEventListener("click", function () {
    const isActive = mobileMenu.classList.toggle("is-active");
    menuToggle.setAttribute("aria-expanded", isActive);
    document.body.style.overflow = isActive ? "hidden" : "";

    // Reset to main panel when opening
    if (isActive) {
      panelHistory = ["main"];
      showPanel("main");
    }
  });

  // Close menu on close button click
  if (menuClose) {
    menuClose.addEventListener("click", function () {
      mobileMenu.classList.remove("is-active");
      menuToggle.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
      panelHistory = ["main"];
      showPanel("main");
    });
  }

  // Function to show a specific panel
  function showPanel(panelId) {
    const menuHeader = mobileMenu.querySelector(".mobile-menu__header");

    // Hide header when showing subpanels, show it for main panel
    if (menuHeader) {
      if (panelId === "main") {
        menuHeader.classList.remove("is-hidden");
      } else {
        menuHeader.classList.add("is-hidden");
      }
    }

    panels.forEach((panel) => {
      const currentPanelId = panel.getAttribute("data-menu-panel");
      if (currentPanelId === panelId) {
        panel.classList.add("is-active");
        // Close all accordions in the newly opened panel
        panel
          .querySelectorAll(".mobile-menu__category-item.is-open")
          .forEach((item) => {
            item.classList.remove("is-open");
            const content = item.querySelector("[data-accordion-content]");
            if (content) content.style.maxHeight = null;
          });
      } else {
        panel.classList.remove("is-active");
      }
    });
  }

  // Handle panel triggers (buttons that navigate to sub-panels)
  const triggers = mobileMenu.querySelectorAll("[data-menu-trigger]");
  triggers.forEach((trigger) => {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      const targetPanel = trigger.getAttribute("data-menu-trigger");
      panelHistory.push(targetPanel);
      showPanel(targetPanel);
    });
  });

  // Handle back buttons
  const backButtons = mobileMenu.querySelectorAll("[data-menu-back]");
  backButtons.forEach((backButton) => {
    backButton.addEventListener("click", function (e) {
      e.preventDefault();
      if (panelHistory.length > 1) {
        panelHistory.pop(); // Remove current panel
        const previousPanel = panelHistory[panelHistory.length - 1];
        showPanel(previousPanel);
      }
    });
  });

  // Handle accordion toggles within panels
  const accordionToggles = mobileMenu.querySelectorAll(
    "[data-accordion-toggle]",
  );
  accordionToggles.forEach((toggle) => {
    toggle.addEventListener("click", function (e) {
      e.preventDefault();
      const parent = toggle.closest(".mobile-menu__category-item");
      const content = parent.querySelector("[data-accordion-content]");
      const isOpen = parent.classList.contains("is-open");

      // Close all other accordions in the same panel
      const currentPanel = toggle.closest("[data-menu-panel]");
      currentPanel
        .querySelectorAll(".mobile-menu__category-item.is-open")
        .forEach((item) => {
          if (item !== parent) {
            item.classList.remove("is-open");
            const itemContent = item.querySelector("[data-accordion-content]");
            if (itemContent) itemContent.style.maxHeight = null;
          }
        });

      // Toggle current accordion
      if (!isOpen) {
        parent.classList.add("is-open");
        content.style.maxHeight = content.scrollHeight + "px";
      } else {
        parent.classList.remove("is-open");
        content.style.maxHeight = null;
      }
    });
  });

  // Close menu on link click
  mobileMenu.querySelectorAll(".mobile-menu__link-list a").forEach((link) => {
    link.addEventListener("click", function () {
      mobileMenu.classList.remove("is-active");
      menuToggle.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
      panelHistory = ["main"];
      showPanel("main");
    });
  });

  // Close menu on simple nav link click (like Contact Us)
  mobileMenu
    .querySelectorAll(".mobile-menu__nav-list > li > a")
    .forEach((link) => {
      link.addEventListener("click", function () {
        mobileMenu.classList.remove("is-active");
        menuToggle.setAttribute("aria-expanded", "false");
        document.body.style.overflow = "";
      });
    });
}

/* Search Modal */
function initSearch() {
  const searchToggle = document.querySelector("[data-search-toggle]");
  if (!searchToggle) return;

  let searchModal = createSearchModal();
  document.body.appendChild(searchModal);

  const searchOverlay = searchModal.querySelector("[data-search-overlay]");
  const searchInput = searchModal.querySelector("[data-search-input]");
  const searchResults = searchModal.querySelector("[data-search-results]");
  const searchClear = searchModal.querySelector("[data-search-clear]");
  const suggestionsContainer = searchModal.querySelector(
    "[data-search-suggestions]",
  );
  const searchClose = searchModal.querySelector("[data-search-close]");
  const trendingTags = searchModal.querySelectorAll("[data-trending-tag]");
  const trendingSection = searchModal.querySelector(".search-modal__trending");
  const resultsSection = searchModal.querySelector(".search-modal__results");

  searchToggle.addEventListener("click", function (e) {
    e.preventDefault();
    searchModal.classList.add("is-open");
    document.body.style.overflow = "hidden";
    setTimeout(() => searchInput.focus(), 100);
  });

  function closeSearch() {
    searchModal.classList.remove("is-open");
    document.body.style.overflow = "";
    searchInput.value = "";
    searchResults.innerHTML = "";
    if (suggestionsContainer) suggestionsContainer.innerHTML = "";
    searchClear.style.display = "none";
    if (trendingSection) trendingSection.style.display = "block";
    if (resultsSection) resultsSection.style.display = "none";
  }

  searchOverlay.addEventListener("click", closeSearch);
  if (searchClose) {
    searchClose.addEventListener("click", closeSearch);
  }

  // Trending tags functionality
  trendingTags.forEach((tag) => {
    tag.addEventListener("click", function () {
      const tagText = this.getAttribute("data-trending-tag");
      searchInput.value = tagText;
      searchInput.dispatchEvent(new Event("input"));
      this.classList.add("is-active");
      trendingTags.forEach((t) => {
        if (t !== this) t.classList.remove("is-active");
      });
    });
  });

  // Clear button functionality
  searchClear.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    searchInput.value = "";
    searchInput.focus();
    searchResults.innerHTML = "";
    suggestionsContainer.innerHTML = "";
    searchClear.style.display = "none";
  });

  // Show/hide clear button based on input
  searchInput.addEventListener("input", function () {
    if (this.value.trim().length > 0) {
      searchClear.style.display = "flex";
    } else {
      searchClear.style.display = "none";
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && searchModal.classList.contains("is-open")) {
      closeSearch();
    }
  });

  let searchTimeout;
  searchInput.addEventListener("input", function () {
    clearTimeout(searchTimeout);
    const query = this.value.trim();

    if (query.length > 2) {
      if (trendingSection) trendingSection.style.display = "none";
      if (resultsSection) resultsSection.style.display = "flex";
      searchTimeout = setTimeout(
        () =>
          performSearch(
            query,
            searchResults,
            suggestionsContainer,
            searchInput,
          ),
        300,
      );
    } else {
      searchResults.innerHTML = "";
      if (suggestionsContainer) suggestionsContainer.innerHTML = "";
      if (trendingSection) trendingSection.style.display = "block";
      if (resultsSection) resultsSection.style.display = "none";
    }
  });
}

function createSearchModal() {
  const modal = document.createElement("div");
  modal.className = "search-modal";
  modal.innerHTML = `
      <div class="search-modal__overlay" data-search-overlay></div>
      <div class="search-modal__content">
        <div class="search-modal__header">
          <div class="search-modal__input-wrapper">
            <svg class="search-modal__search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
            <input type="search" class="search-modal__input" placeholder="What are you looking for today?" data-search-input>
            <button class="search-modal__clear" data-search-clear style="display: none;">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <button class="search-modal__close" data-search-close>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        <div class="search-modal__body">
          <div class="search-modal__trending">
            <div class="search-modal__trending-header">
              <svg class="search-modal__trending-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                <polyline points="17 6 23 6 23 12"></polyline>
              </svg>
              <h3>TRENDING SEARCHES</h3>
            </div>
            <div class="search-modal__trending-tags" data-trending-tags>
              <button class="trending-tag" data-trending-tag="leather jacket">LEATHER JACKET</button>
              <button class="trending-tag" data-trending-tag="bomber jacket">BOMBER JACKET</button>
              <button class="trending-tag" data-trending-tag="biker jacket">BIKER JACKET</button>
              <button class="trending-tag" data-trending-tag="aviator jacket">AVIATOR JACKET</button>
            </div>
          </div>
          <div class="search-modal__results" style="display: none;">
            <div class="search-modal__suggestions">
              <h3>SUGGESTIONS</h3>
              <div class="search-suggestions" data-search-suggestions></div>
            </div>
            <div class="search-modal__products">
              <h3>PRODUCTS</h3>
              <div class="search-products" data-search-results></div>
            </div>
          </div>
        </div>
      </div>
    `;
  return modal;
}

function formatProductForSearch(product) {
  // Get featured image - use first image from images array
  let imageUrl = "";
  if (product.images && product.images.length > 0) {
    const img = product.images[0];
    if (typeof img === "string") {
      imageUrl = img;
    } else if (img.src) {
      imageUrl = img.src;
    } else if (img.url) {
      imageUrl = img.url;
    }

    // Ensure full URL
    if (imageUrl) {
      if (imageUrl.startsWith("//")) {
        imageUrl = "https:" + imageUrl;
      } else if (imageUrl.startsWith("/")) {
        imageUrl = window.location.origin + imageUrl;
      }
      // Add width parameter for optimization
      if (imageUrl.includes("cdn.shopify.com")) {
        imageUrl = imageUrl.replace(/\?.*$/, "") + "?width=600";
      }
    }
  }

  // Get price from variants
  const variant =
    product.variants && product.variants.length > 0
      ? product.variants[0]
      : null;

  // Get product URL
  const productUrl = product.url
    ? product.url.startsWith("/")
      ? window.location.origin + product.url
      : product.url
    : product.handle
      ? `/products/${product.handle}`
      : "#";

  if (!variant) {
    return {
      image:
        imageUrl ||
        "",
      title: product.title || "Product",
      price: "",
      comparePrice: null,
      fit: "Regular Fit",
      color: "Black",
      url: productUrl,
    };
  }

  const price =
    typeof variant.price === "number"
      ? variant.price
      : parseInt(String(variant.price || 0), 10);
  const comparePrice =
    variant.compare_at_price && variant.compare_at_price > variant.price
      ? typeof variant.compare_at_price === "number"
        ? variant.compare_at_price
        : parseInt(String(variant.compare_at_price || 0), 10)
      : null;

  const priceNumber = Math.floor(price / 100);
  const formattedPrice = window.Shopify && window.Shopify.currency
    ? `${window.Shopify.currency.active} ${priceNumber.toLocaleString()}`
    : `${priceNumber.toLocaleString()}`;

  const comparePriceNumber = comparePrice ? Math.floor(comparePrice / 100) : null;
  const formattedComparePrice = comparePriceNumber
    ? (window.Shopify && window.Shopify.currency
        ? `${window.Shopify.currency.active} ${comparePriceNumber.toLocaleString()}`
        : `${comparePriceNumber.toLocaleString()}`)
    : null;

  // Extract fit and color
  let fit = "Regular Fit";
  let color = "Black";
  const titleLower = product.title.toLowerCase();

  if (titleLower.includes("slim")) fit = "Slim Fit";
  if (titleLower.includes("oversized")) fit = "Oversized Fit";

  const colorKeywords = [
    "black",
    "white",
    "gray",
    "grey",
    "red",
    "blue",
    "green",
    "brown",
    "beige",
    "navy",
  ];
  for (const keyword of colorKeywords) {
    if (titleLower.includes(keyword)) {
      color = keyword.charAt(0).toUpperCase() + keyword.slice(1);
      break;
    }
  }

  return {
    image:
      imageUrl ||
      "",
    title: product.title || "Product",
    price: formattedPrice,
    comparePrice: formattedComparePrice,
    fit: fit,
    color: color,
    url: productUrl,
  };
}

function performSearch(
  query,
  resultsContainer,
  suggestionsContainer,
  searchInput,
) {
  // Generate suggestions based on query and actual products
  const queryLower = query.toLowerCase();
  const suggestions = [];

  // Try to fetch actual product suggestions from Shopify's search suggest API
  fetch(
    `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`,
  )
    .then((response) => response.json())
    .then((data) => {
      if (
        data.resources &&
        data.resources.results &&
        data.resources.results.products
      ) {
        const products = data.resources.results.products;
        products.forEach((product) => {
          const title = product.title || "";
          suggestions.push(
            `<div class="suggestion-item"><strong>${query}</strong> ${title}</div>`,
          );
        });
      }

      // If no API results, create generic suggestions
      if (suggestions.length === 0) {
        suggestions.push(
          `<div class="suggestion-item"><strong>${query}</strong> for men</div>`,
        );
        suggestions.push(
          `<div class="suggestion-item"><strong>${query}</strong> for women</div>`,
        );
        suggestions.push(
          `<div class="suggestion-item">mens <strong>${query}</strong></div>`,
        );
      }

      suggestionsContainer.innerHTML = suggestions.join("");

      // Add click handlers
      suggestionsContainer
        .querySelectorAll(".suggestion-item")
        .forEach((item) => {
          item.addEventListener("click", function () {
            const suggestionText = this.textContent.trim();
            searchInput.value = suggestionText;
            searchInput.dispatchEvent(new Event("input"));
          });
        });
    })
    .catch(() => {
      // Fallback suggestions
      suggestions.push(
        `<div class="suggestion-item"><strong>${query}</strong> for men</div>`,
      );
      suggestions.push(
        `<div class="suggestion-item"><strong>${query}</strong> for women</div>`,
      );
      suggestions.push(
        `<div class="suggestion-item">mens <strong>${query}</strong></div>`,
      );

      suggestionsContainer.innerHTML = suggestions.join("");

      suggestionsContainer
        .querySelectorAll(".suggestion-item")
        .forEach((item) => {
          item.addEventListener("click", function () {
            const suggestionText = this.textContent.trim();
            searchInput.value = suggestionText;
            searchInput.dispatchEvent(new Event("input"));
          });
        });
    });

  // First, try to get product handles from search, then fetch full product data from products.json
  Promise.all([
    fetch(
      `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`,
    ).catch(() => null),
    fetch("/products.json?limit=250").catch(() => null),
  ])
    .then(([searchResponse, productsResponse]) => {
      // Get all products from products.json
      if (!productsResponse || !productsResponse.ok) {
        // If products.json fails, try direct search
        return fetch(
          `/search?q=${encodeURIComponent(query)}&type=product&view=json`,
        )
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            throw new Error("Search failed");
          })
          .then((data) => {
            // Handle direct search response
            return (data.products || []).slice(0, 4).map((product) => {
              return formatProductForSearch(product);
            });
          });
      }

      return productsResponse.json().then((productsData) => {
        let matchingProducts = [];

        // If we have search results, use them to filter
        if (searchResponse && searchResponse.ok) {
          return searchResponse.json().then((searchData) => {
            if (
              searchData.resources &&
              searchData.resources.results &&
              searchData.resources.results.products
            ) {
              const searchHandles = searchData.resources.results.products
                .map(
                  (p) =>
                    p.handle || p.url?.split("/products/")[1]?.split("?")[0],
                )
                .filter(Boolean);
              matchingProducts = productsData.products.filter((p) => {
                return (
                  searchHandles.includes(p.handle) ||
                  p.title.toLowerCase().includes(query.toLowerCase()) ||
                  p.tags?.some((tag) =>
                    tag.toLowerCase().includes(query.toLowerCase()),
                  )
                );
              });
            } else {
              // Fallback: search in all products
              matchingProducts = productsData.products.filter((p) => {
                return (
                  p.title.toLowerCase().includes(query.toLowerCase()) ||
                  p.tags?.some((tag) =>
                    tag.toLowerCase().includes(query.toLowerCase()),
                  ) ||
                  p.product_type?.toLowerCase().includes(query.toLowerCase()) ||
                  p.vendor?.toLowerCase().includes(query.toLowerCase())
                );
              });
            }

            return matchingProducts.slice(0, 4).map((product) => {
              return formatProductForSearch(product);
            });
          });
        } else {
          // No search API, filter directly from products.json
          matchingProducts = productsData.products.filter((p) => {
            return (
              p.title.toLowerCase().includes(query.toLowerCase()) ||
              p.tags?.some((tag) =>
                tag.toLowerCase().includes(query.toLowerCase()),
              ) ||
              p.product_type?.toLowerCase().includes(query.toLowerCase()) ||
              p.vendor?.toLowerCase().includes(query.toLowerCase())
            );
          });

          return matchingProducts.slice(0, 4).map((product) => {
            return formatProductForSearch(product);
          });
        }
      });
    })
    .then((products) => {
      if (!products || products.length === 0) {
        resultsContainer.innerHTML =
          '<div class="search-empty">No products found</div>';
        return;
      }

      const productsHTML = products
        .map(
          (product) => `
          <a href="${product.url}" class="product-item">
            <div class="product-item__image-wrapper">
              <img src="${product.image}" alt="${product.title}" loading="lazy" onerror="this.style.display='none'; this.onerror=null;">
              <button class="product-wishlist" onclick="event.preventDefault(); event.stopPropagation();">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                </svg>
              </button>
            </div>
            <div class="product-info">
              ${product.rating ? `<div class="product-rating">★${product.rating}</div>` : ""}
              <h4>${product.title}</h4>
              <p class="product-fit">${product.fit}</p>
              <p class="product-color">Color: ${product.color}</p>
              <div class="product-price">
                ${product.comparePrice ? `<span class="product-price__original">${product.comparePrice}</span>` : ""}
                <span>${product.price}</span>
              </div>
            </div>
          </a>
        `,
        )
        .join("");

      resultsContainer.innerHTML = productsHTML;

      // Add "View all" link if there are products
      if (products.length > 0) {
        const viewAllLink = document.createElement("a");
        viewAllLink.href = `/search?q=${encodeURIComponent(query)}&type=product`;
        viewAllLink.className = "view-all-link";
        viewAllLink.textContent = `View all '${query}'`;
        resultsContainer.appendChild(viewAllLink);
      }
    })
    .catch((error) => {
      console.error("Search error:", error);
      resultsContainer.innerHTML =
        '<div class="search-error">Unable to search products. Please try again.</div>';
    });
}
function initMegaMenu() {
  const navItems = document.querySelectorAll("[data-mega-menu]");
  const megaMenus = document.querySelectorAll("[data-mega-menu-panel]");
  const closeButtons = document.querySelectorAll("[data-mega-menu-close]");
  let activeMenu = null;

  if (!navItems.length || !megaMenus.length) return;

  // Handle click on all screen sizes
  navItems.forEach((item) => {
    const menuType = item.dataset.megaMenu;
    const megaMenu = document.querySelector(
      `[data-mega-menu-panel="${menuType}"]`,
    );
    const navLink = item.querySelector(".site-header__nav-link");

    if (!megaMenu) return;

    // Click to toggle menu (works on all screen sizes)
    navLink.addEventListener("click", function (e) {
      e.preventDefault();
      if (activeMenu === megaMenu) {
        closeMenu(megaMenu, item);
      } else {
        closeAllMenus();
        openMenu(megaMenu, item);
      }
    });
  });

  // Close buttons
  closeButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const megaMenu = this.closest(".mega-menu");
      const navItem = document.querySelector(
        `[data-mega-menu="${megaMenu.dataset.megaMenuPanel}"]`,
      );
      if (megaMenu && navItem) {
        closeMenu(megaMenu, navItem);
      }
    });
  });

  // Close on outside click (works on all screen sizes)
  document.addEventListener("click", function (e) {
    const clickedInside =
      e.target.closest(".site-header__nav-item--has-mega-menu") ||
      e.target.closest(".mega-menu");
    if (!clickedInside && activeMenu) {
      const navItem = document.querySelector(
        `[data-mega-menu="${activeMenu.dataset.megaMenuPanel}"]`,
      );
      if (navItem) {
        closeMenu(activeMenu, navItem);
      }
    }
  });

  // Close on escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && activeMenu) {
      const navItem = document.querySelector(
        `[data-mega-menu="${activeMenu.dataset.megaMenuPanel}"]`,
      );
      if (navItem) {
        closeMenu(activeMenu, navItem);
      }
    }
  });

  // Close all menus function
  function closeAllMenus() {
    megaMenus.forEach((menu) => {
      const navItem = document.querySelector(
        `[data-mega-menu="${menu.dataset.megaMenuPanel}"]`,
      );
      if (navItem) {
        closeMenu(menu, navItem);
      }
    });
  }

  // Open menu function
  function openMenu(menu, navItem) {
    menu.classList.add("is-active");
    navItem.classList.add("is-active");
    activeMenu = menu;
    document.body.style.overflow = window.innerWidth < 1025 ? "hidden" : "";
  }

  // Close menu function
  function closeMenu(menu, navItem) {
    menu.classList.remove("is-active");
    navItem.classList.remove("is-active");
    if (activeMenu === menu) {
      activeMenu = null;
    }
    document.body.style.overflow = "";
  }

  // Handle window resize - close menus on resize
  window.addEventListener("resize", function () {
    closeAllMenus();
  });
}

/* Product Gallery */
function initProductGallery() {
  const thumbs = document.querySelectorAll("[data-thumb]");
  const mainImage = document.getElementById("ProductMainImage");

  if (!thumbs.length || !mainImage) return;

  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", function () {
      // Update main image
      mainImage.src = this.dataset.imageUrl;
      mainImage.alt = this.dataset.imageAlt;

      // Update active state
      thumbs.forEach((t) => t.classList.remove("is-active"));
      this.classList.add("is-active");
    });
  });
}

/* Quantity Buttons */
function initQuantityButtons() {
  document.addEventListener("click", function (e) {
    const isCartPage = window.location.pathname.includes("/cart");
    if (isCartPage) return;

    const minusBtn = e.target.closest("[data-quantity-minus]");
    const plusBtn = e.target.closest("[data-quantity-plus]");

    if (minusBtn) {
      const input = minusBtn.parentElement.querySelector(
        '[data-quantity-input], input[type="number"]',
      );
      if (input) {
        const currentValue = parseInt(input.value) || 1;
        const minValue = parseInt(input.min) || 1;
        if (currentValue > minValue) {
          input.value = currentValue - 1;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    }

    if (plusBtn) {
      const input = plusBtn.parentElement.querySelector(
        '[data-quantity-input], input[type="number"]',
      );
      if (input) {
        const currentValue = parseInt(input.value) || 1;
        const maxValue = parseInt(input.max) || Infinity;
        if (currentValue < maxValue) {
          input.value = currentValue + 1;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    }
  });
}

/* Add to Cart */
function initAddToCart() {
  // Quick add to cart from product cards
  document.addEventListener("click", function (e) {
    const addBtn = e.target.closest("[data-add-to-cart]");
    if (!addBtn) return;

    // Check if button is disabled
    if (addBtn.disabled) {
      return;
    }

    e.preventDefault();
    const variantId = addBtn.dataset.addToCart;

    // Validate variant ID before proceeding
    if (
      !variantId ||
      variantId === "undefined" ||
      variantId === "null" ||
      variantId === ""
    ) {
      console.error("Invalid variant ID from button:", variantId);
      alert(
        "Unable to add this item to cart. Please refresh the page and try again.",
      );
      return;
    }

    // Disable button to prevent multiple clicks
    addBtn.disabled = true;
    const originalText = addBtn.textContent;
    addBtn.textContent = "Adding...";

    // Add to cart without page reload
    const data = {
      items: [
        {
          id: parseInt(variantId, 10),
          quantity: 1,
        },
      ],
    };

    fetch(window.routes.cart_add_url + ".js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to add item to cart");
        }
        return response.json();
      })
      .then((cartData) => {
        // Update cart without reloading
        if (typeof updateCartCount === "function") updateCartCount();
        if (typeof loadCartSidebar === "function") loadCartSidebar();
        if (typeof openCartSidebar === "function") openCartSidebar();
        if (typeof showCartSidebarBanner === "function")
          showCartSidebarBanner();

        // Reset button
        addBtn.textContent = originalText;
        addBtn.disabled = false;
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
        addBtn.textContent = originalText;
        addBtn.disabled = false;
        alert("Failed to add item to cart. Please try again.");
      });
  });

  // Product form submission
  const productForm = document.querySelector("[data-product-form]");
  if (productForm) {
    productForm.addEventListener("submit", function (e) {
      e.preventDefault();

      const formData = new FormData(this);
      const variantId = formData.get("id");
      const quantity = formData.get("quantity") || 1;

      addToCart(variantId, quantity);
    });
  }
}

function addToCart(variantId, quantity = 1) {
  // Validate variant ID
  if (!variantId || variantId === "undefined" || variantId === "null") {
    console.error("Invalid variant ID:", variantId);
    alert("Please select a product variant before adding to cart.");
    return;
  }

  // Find and disable the submit button
  const productForm = document.querySelector("[data-product-form]");
  let submitBtn = null;
  if (productForm) {
    submitBtn = productForm.querySelector("button[type='submit']");
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.originalText = submitBtn.textContent;
      submitBtn.textContent = "Adding...";
    }
  }

  // Convert variant ID to number if it's a string
  const numericVariantId =
    typeof variantId === "string" ? parseInt(variantId, 10) : variantId;

  if (isNaN(numericVariantId)) {
    console.error("Variant ID is not a valid number:", variantId);
    alert("Invalid product variant. Please try again.");
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = submitBtn.dataset.originalText;
    }
    return;
  }

  const data = {
    items: [
      {
        id: numericVariantId,
        quantity: parseInt(quantity) || 1,
      },
    ],
  };

  if (!window.routes || !window.routes.cart_add_url) {
    console.error("Cart routes not defined");
    alert("Cart system not initialized. Please refresh the page.");
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = submitBtn.dataset.originalText;
    }
    return;
  }

  fetch(window.routes.cart_add_url + ".js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to add item to cart");
      }
      return response.json();
    })
    .then((cartData) => {
      // Update cart without reloading page
      if (typeof updateCartCount === "function") updateCartCount();
      if (typeof loadCartSidebar === "function") loadCartSidebar();
      if (typeof openCartSidebar === "function") openCartSidebar();
      if (typeof showCartSidebarBanner === "function") showCartSidebarBanner();

      // Reset button
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.dataset.originalText;
      }
    })
    .catch((error) => {
      console.error("Error adding to cart:", error);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.dataset.originalText;
      }
      alert("Failed to add item to cart. Please try again.");
    });
}

function updateCartCount() {
  if (!window.routes || !window.routes.cart_url) {
    return;
  }

  fetch(window.routes.cart_url + ".js")
    .then((response) => {
      if (!response.ok) {
        // Don't update count if cart fetch fails
        return null;
      }
      return response.json();
    })
    .then((cart) => {
      if (cart && cart.item_count !== undefined) {
        const countElements = document.querySelectorAll("[data-cart-count]");
        countElements.forEach((el) => {
          el.textContent = cart.item_count || 0;
        });
      }
    })
    .catch((error) => {
      // Silently fail - don't show errors for cart count updates
      console.error("Error updating cart count:", error);
    });
}

/* Cart Sidebar */
function initCartSidebar() {
  const sidebar = document.querySelector("[data-cart-sidebar]");
  if (!sidebar) return;

  // Ensure cart sidebar CSS is loaded by checking computed styles
  const checkCSSLoaded = () => {
    const sidebarStyles = window.getComputedStyle(sidebar);
    return (
      sidebarStyles.position === "fixed" && sidebarStyles.zIndex !== "auto"
    );
  };

  // Wait for CSS to be fully loaded before initializing
  if (!checkCSSLoaded()) {
    setTimeout(() => {
      initCartSidebar();
    }, 100);
    return;
  }

  // Toggle sidebar from header cart button
  const cartToggle = document.querySelector("[data-cart-toggle]");
  if (cartToggle) {
    cartToggle.addEventListener("click", function (e) {
      e.preventDefault();
      // Don't open sidebar on cart page - redirect to cart instead
      const isCartPage =
        window.location.pathname.includes("/cart") ||
        window.location.pathname === "/cart";
      if (isCartPage) {
        window.location.href = window.routes.cart_url;
        return;
      }
      // Add small delay to ensure CSS is loaded
      setTimeout(() => {
        openCartSidebar();
      }, 100);
    });
  }

  // Close sidebar handlers
  const closeBtn = sidebar.querySelector("[data-cart-sidebar-close]");
  const overlay = sidebar.querySelector("[data-cart-sidebar-overlay]");

  if (closeBtn) {
    closeBtn.addEventListener("click", closeCartSidebar);
  }

  if (overlay) {
    overlay.addEventListener("click", closeCartSidebar);
  }

  // Close on ESC key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && sidebar.classList.contains("is-open")) {
      closeCartSidebar();
    }
  });

  // Discount code handler
  const discountInput = sidebar.querySelector(
    "[data-cart-sidebar-discount-input]",
  );
  const discountApplyBtn = sidebar.querySelector(
    "[data-cart-sidebar-discount-apply]",
  );
  const discountMessage = sidebar.querySelector(
    "[data-cart-sidebar-discount-message]",
  );

  if (discountInput && discountApplyBtn) {
    const showDiscountMessage = function (message, type) {
      if (!discountMessage) return;
      discountMessage.textContent = message;
      discountMessage.className = "cart-sidebar__discount-message";
      discountMessage.classList.add(
        "cart-sidebar__discount-message--" + (type || "info"),
      );
      discountMessage.style.display = "block";

      if (type === "success") {
        setTimeout(() => {
          discountMessage.style.display = "none";
        }, 3000);
      }
    };

    const applyDiscount = function (e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      const code = discountInput.value.trim();
      if (!code) {
        showDiscountMessage("Please enter a discount code", "error");
        return;
      }

      // Create form and submit to checkout with discount
      const form = document.createElement("form");
      form.action = "/checkout";
      form.method = "get";

      const discountField = document.createElement("input");
      discountField.type = "hidden";
      discountField.name = "discount";
      discountField.value = code;

      form.appendChild(discountField);
      document.body.appendChild(form);
      form.submit();
    };

    // Prevent clicks on discount section from closing sidebar
    const discountSection = sidebar.querySelector(
      "[data-cart-sidebar-discount]",
    );
    if (discountSection) {
      discountSection.addEventListener("click", function (e) {
        e.stopPropagation();
      });
    }

    discountApplyBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      applyDiscount(e);
      return false;
    });

    discountInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        applyDiscount(e);
        return false;
      }
    });

    discountInput.addEventListener("click", function (e) {
      e.stopPropagation();
    });
  }

  // Quantity update handlers - removed, handled by DOMContentLoaded

  // Load initial cart (but don't show sidebar)
  // Cart will be loaded when sidebar opens
}

// Store scroll position when opening sidebar
let savedScrollPosition = 0;

function openCartSidebar() {
  const sidebar = document.querySelector("[data-cart-sidebar]");
  if (sidebar) {
    console.log("Opening cart sidebar");

    // Ensure CSS is loaded by checking if cart sidebar has proper styles
    const sidebarStyles = window.getComputedStyle(sidebar);
    if (sidebarStyles.position !== "fixed") {
      // CSS not loaded yet, wait a bit longer
      setTimeout(() => {
        openCartSidebar();
      }, 200);
      return;
    }

    // Save current scroll position
    savedScrollPosition =
      window.pageYOffset || document.documentElement.scrollTop;

    sidebar.classList.add("is-open");
    document.documentElement.classList.add("cart-sidebar-open");
    document.body.classList.add("cart-sidebar-open");

    // Fix body position to prevent scroll
    document.body.style.top = `-${savedScrollPosition}px`;

    // Always load fresh cart data when opening
    setTimeout(() => {
      loadCartSidebar();
    }, 100);
  } else {
    console.error("Cart sidebar not found");
  }
}

function closeCartSidebar() {
  const sidebar = document.querySelector("[data-cart-sidebar]");
  if (sidebar) {
    sidebar.classList.remove("is-open");
    document.documentElement.classList.remove("cart-sidebar-open");
    document.body.classList.remove("cart-sidebar-open");

    // Restore scroll position
    document.body.style.top = "";
    window.scrollTo(0, savedScrollPosition);
  }
}

function showCartSidebarBanner() {
  const banner = document.querySelector("[data-cart-sidebar-banner]");
  if (banner) {
    banner.style.display = "flex";
  }
}

function formatMoney(cents) {
  // Ensure cents is a valid number
  const amount = typeof cents === "number" ? cents : parseInt(cents, 10) || 0;

  // Use Shopify's formatMoney if available and configured
  if (
    typeof Shopify !== "undefined" &&
    Shopify.formatMoney &&
    Shopify.money_format
  ) {
    return Shopify.formatMoney(amount, Shopify.money_format);
  }

  // Fallback: Get currency symbol from page or default to $
  let currencySymbol = "$";
  const priceEl = document.querySelector("[data-product-price]");
  if (priceEl) {
    const priceText = priceEl.textContent;
    const match = priceText.match(/^([^\d]+)/);
    if (match) currencySymbol = match[1].trim();
  }

  const value = (amount / 100).toFixed(2);
  const parts = value.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return currencySymbol + parts.join(".");
}

// Utility function to escape HTML to prevent XSS
function escapeHtml(text) {
  if (text == null) return "";
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}

function loadCartSidebar() {
  // Don't load cart sidebar if we're on the cart page itself
  const isCartPage =
    window.location.pathname.includes("/cart") ||
    window.location.pathname === "/cart" ||
    (window.routes &&
      window.location.pathname ===
        window.routes.cart_url.replace(window.shopUrl || "", ""));

  if (isCartPage) {
    return;
  }

  if (!window.routes || !window.routes.cart_url) {
    console.error("Cart routes not defined");
    return;
  }

  // Check if cart sidebar exists before trying to load
  const sidebar = document.querySelector("[data-cart-sidebar]");
  if (!sidebar) {
    return; // Cart sidebar doesn't exist on this page
  }

  const cartUrl = window.routes.cart_url + ".js";

  // Simple fetch without complex error handling
  fetch(cartUrl)
    .then((response) => {
      if (!response.ok && response.status !== 404) {
        throw new Error("Cart API returned: " + response.status);
      }
      return response.json().catch(() => {
        // If JSON parse fails, return empty cart
        return { items: [], item_count: 0, total_price: 0 };
      });
    })
    .then((cart) => {
      // Ensure cart has required properties
      if (!cart) cart = { items: [], item_count: 0, total_price: 0 };
      if (!cart.items) cart.items = [];
      if (cart.item_count === undefined) cart.item_count = cart.items.length;
      if (cart.total_price === undefined) cart.total_price = 0;

      updateCartCount();
      updateCartItemsHTML(cart);
      updateCartSubtotal(cart);
    })
    .catch((error) => {
      console.error("Error loading cart:", error);

      // Only show error if sidebar is actually open
      const sidebar = document.querySelector("[data-cart-sidebar]");
      if (sidebar && sidebar.classList.contains("is-open")) {
        const itemsContainer = sidebar.querySelector(
          "[data-cart-sidebar-items]",
        );
        const emptyContainer = sidebar.querySelector(
          "[data-cart-sidebar-empty]",
        );

        if (itemsContainer) {
          itemsContainer.innerHTML =
            '<p style="padding: 2rem; text-align: center; color: #999;">Unable to load cart items. Please try again.</p>';
        }
        if (emptyContainer) {
          emptyContainer.style.display = "none";
        }

        // Hide subtotal on error since it might be stale
        const subtotalEl = sidebar.querySelector(
          "[data-cart-sidebar-subtotal]",
        );
        if (subtotalEl) {
          subtotalEl.textContent = "";
        }
      }
    });
}

function updateCartItemsHTML(cart) {
  const sidebar = document.querySelector("[data-cart-sidebar]");
  if (!sidebar) return;

  const itemsContainer = sidebar.querySelector("[data-cart-sidebar-items]");
  const emptyContainer = sidebar.querySelector("[data-cart-sidebar-empty]");
  const banner = sidebar.querySelector("[data-cart-sidebar-banner]");

  if (!itemsContainer || !emptyContainer) return;

  // Handle empty cart
  if (
    !cart ||
    cart.item_count === 0 ||
    !cart.items ||
    cart.items.length === 0
  ) {
    itemsContainer.innerHTML = "";
    emptyContainer.style.display = "flex";
    if (banner) banner.style.display = "none";
    return;
  }

  emptyContainer.style.display = "none";

  try {
    itemsContainer.innerHTML = cart.items
      .map((item) => {
        const imageUrl = item.image
          ? item.image.startsWith("//")
            ? `https:${item.image}`
            : item.image
          : "";
        const productTitle = escapeHtml(
          item.product?.title || item.title || "",
        );
        const cleanTitle = productTitle.replace(/ - [^-]*$/, "");
        const itemUrl =
          item.url || (item.product ? `/products/${item.product.handle}` : "#");
        const unitPrice = formatMoney(item.price);
        const totalPrice = formatMoney(item.line_price);

        // Extract color and size
        let color = "";
        let size = "";

        if (item.options_with_values?.length > 0) {
          item.options_with_values.forEach((option) => {
            const name = option.name?.toLowerCase() || "";
            if (name.includes("color") || name.includes("colour")) {
              color = option.value || "";
            } else if (name.includes("size")) {
              size = option.value || "";
            }
          });
        }

        const colorText = escapeHtml(color);
        const sizeText = escapeHtml(size);

        // Mobile layout
        const mobileLayout = `
          <div class="cart-sidebar-mobile-item cart-sidebar-mobile-only" data-cart-item-id="${item.key}">
            <div class="cart-sidebar-item__loading-overlay" data-loading-overlay style="display: none;">
              <div class="cart-sidebar-item__spinner"></div>
            </div>
            <button class="cart-sidebar-mobile-item__remove" data-cart-remove="${item.key}" aria-label="Remove item">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
              </svg>
            </button>
            <div class="cart-sidebar-mobile-item__image-wrapper">
              ${imageUrl ? `<img alt="${escapeHtml(item.product?.title || "")}" loading="lazy" decoding="async" class="cart-sidebar-mobile-item__image" src="${escapeHtml(imageUrl)}">` : '<div class="cart-sidebar-mobile-item__image" style="background: #f5f5f5;"></div>'}
              <button class="cart-sidebar-mobile-item__wishlist">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.682l-1.318-1.364a4.5 4.5 0 00-6.364 0z"></path>
                </svg>
              </button>
            </div>
            <div class="cart-sidebar-mobile-item__details">
              <h3 class="cart-sidebar-mobile-item__title">
                <a href="${escapeHtml(itemUrl)}">${cleanTitle}</a>
              </h3>
              <div class="cart-sidebar-mobile-item__variant-info">
                <div class="cart-sidebar-mobile-item__variants">
                  ${colorText ? `<p class="cart-sidebar-mobile-item__variant"><span class="cart-sidebar-mobile-item__variant-label">Color:</span> ${colorText}</p>` : ""}
                  ${sizeText ? `<p class="cart-sidebar-mobile-item__variant"><span class="cart-sidebar-mobile-item__variant-label">Size:</span> ${sizeText}</p>` : ""}
                </div>
              </div>
              <div class="cart-sidebar-mobile-item__bottom">
                <div class="cart-sidebar-mobile-item__quantity">
                  <button class="cart-sidebar-mobile-item__quantity-btn" onclick="decreaseQuantity('${item.key}')" ${item.quantity <= 1 ? "" : ""}>−</button>
                  <span class="cart-sidebar-mobile-item__quantity-display" id="qty-mobile-${item.key}">${item.quantity}</span>
                  <button class="cart-sidebar-mobile-item__quantity-btn" onclick="increaseQuantity('${item.key}')">+</button>
                </div>
                <div class="cart-sidebar-mobile-item__pricing">
                  <p class="cart-sidebar-mobile-item__total-label">Total Price</p>
                  <p class="cart-sidebar-mobile-item__total-price" id="total-mobile-${item.key}" data-unit-price="${item.final_price}">${totalPrice}</p>
                </div>
              </div>
            </div>
          </div>
        `;

        // Desktop layout
        const desktopLayout = `
          <div class="cart-sidebar-item cart-sidebar-desktop-only" data-cart-item-id="${item.key}">
            <div class="cart-sidebar-item__loading-overlay" data-loading-overlay style="display: none;">
              <div class="cart-sidebar-item__spinner"></div>
            </div>
            <button class="cart-sidebar-item__remove" data-cart-remove="${item.key}" aria-label="Remove item">
              <svg class="cart-sidebar-item__remove-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
              </svg>
            </button>
            <div class="cart-sidebar-item__content">
              <div class="cart-sidebar-item__image-wrapper">
                ${imageUrl ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(item.product?.title || "")}" class="cart-sidebar-item__image">` : '<div class="cart-sidebar-item__image" style="background: #f5f5f5;"></div>'}
                <button class="cart-sidebar-item__wishlist">
                  <svg class="cart-sidebar-item__heart" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                  </svg>
                </button>
              </div>
              <div class="cart-sidebar-item__details">
                <h3 class="cart-sidebar-item__title">
                  <a href="${escapeHtml(itemUrl)}">${cleanTitle}</a>
                </h3>
                <div class="cart-sidebar-item__variant-info">
                  ${colorText ? `<p class="cart-sidebar-item__variant"><span class="cart-sidebar-item__variant-label">Color:</span> <span class="cart-sidebar-item__variant-value">${colorText}</span></p>` : ""}
                  ${sizeText ? `<p class="cart-sidebar-item__variant"><span class="cart-sidebar-item__variant-label">Size:</span> <span class="cart-sidebar-item__variant-value">${sizeText}</span></p>` : ""}
                </div>
                <div class="cart-sidebar-item__quantity-wrapper">
                  <div class="cart-sidebar-item__quantity">
                    <button class="cart-sidebar-item__quantity-btn" onclick="decreaseQuantity('${item.key}')" ${item.quantity <= 1 ? "" : ""}>−</button>
                    <div class="cart-sidebar-item__quantity-display" id="qty-${item.key}">${item.quantity}</div>
                    <button class="cart-sidebar-item__quantity-btn" onclick="increaseQuantity('${item.key}')">+</button>
                  </div>
                </div>
                <div class="cart-sidebar-item__pricing">
                  <div class="cart-sidebar-item__unit-price">
                    <p class="cart-sidebar-item__unit-label">Unit Price</p>
                    <div class="cart-sidebar-item__price-display">
                      <span class="cart-sidebar-item__current-price">${unitPrice}</span>
                    </div>
                  </div>
                  <div class="cart-sidebar-item__total">
                    <p class="cart-sidebar-item__total-label">Total Price</p>
                    <p class="cart-sidebar-item__total-price" id="total-${item.key}" data-unit-price="${item.final_price}">${totalPrice}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;

        return mobileLayout + desktopLayout;
      })
      .join("");
  } catch (error) {
    console.error("Error updating cart items HTML:", error);
  }
}

function renderCartItems(cart) {
  const sidebar = document.querySelector("[data-cart-sidebar]");
  if (!sidebar) {
    return; // Sidebar doesn't exist
  }

  const itemsContainer = sidebar.querySelector("[data-cart-sidebar-items]");
  const emptyContainer = sidebar.querySelector("[data-cart-sidebar-empty]");

  if (!itemsContainer || !emptyContainer) {
    console.error("Cart sidebar containers not found");
    return;
  }

  // Handle empty cart
  if (
    !cart ||
    cart.item_count === 0 ||
    !cart.items ||
    cart.items.length === 0
  ) {
    itemsContainer.innerHTML = "";
    emptyContainer.style.display = "flex";
    return;
  }

  emptyContainer.style.display = "none";

  // Log items for debugging
  console.log("Rendering", cart.items.length, "cart items");

  try {
    itemsContainer.innerHTML = cart.items
      .map((item) => {
        const hasComparePrice =
          item.variant &&
          item.variant.compare_at_price &&
          item.variant.compare_at_price > item.price;
        const unitPrice = formatMoney(item.price);
        const comparePrice = hasComparePrice
          ? formatMoney(item.variant.compare_at_price)
          : "";
        const totalPrice = formatMoney(item.line_price);

        // Extract color and size from variant options
        let color = "";
        let size = "";

        // Method 1: Use options_with_values from Shopify cart API (most reliable)
        if (item.options_with_values && item.options_with_values.length > 0) {
          item.options_with_values.forEach((option) => {
            const optionName = option.name ? option.name.toLowerCase() : "";
            const optionValue = option.value || "";
            if (optionName.includes("color") || optionName.includes("colour")) {
              color = optionValue;
            } else if (optionName.includes("size")) {
              size = optionValue;
            }
          });
        }

        // Method 2: Use variant_options array from cart API
        if (
          (!color || !size) &&
          item.variant_options &&
          item.variant_options.length > 0
        ) {
          // variant_options is typically in order: [Color, Size] or depends on product setup
          item.variant_options.forEach((optValue, index) => {
            if (optValue && optValue !== "Default Title") {
              const colorKeywords = [
                "black",
                "white",
                "grey",
                "gray",
                "navy",
                "blue",
                "red",
                "green",
                "brown",
                "beige",
                "tan",
                "yellow",
                "orange",
                "pink",
                "purple",
                "leather",
                "suede",
              ];
              const sizeKeywords = [
                "xs",
                "sm",
                "s",
                "m",
                "l",
                "xl",
                "xxl",
                "xxxl",
                "2xl",
                "3xl",
                "small",
                "medium",
                "large",
                "extra",
              ];
              const valueLower = optValue.toLowerCase();

              if (
                !color &&
                colorKeywords.some((keyword) => valueLower.includes(keyword))
              ) {
                color = optValue;
              } else if (
                !size &&
                (sizeKeywords.some(
                  (keyword) =>
                    valueLower === keyword || valueLower.includes(keyword),
                ) ||
                  /^\d/.test(optValue))
              ) {
                size = optValue;
              } else if (index === 0 && !color) {
                // First option is typically color
                color = optValue;
              } else if (index === 1 && !size) {
                // Second option is typically size
                size = optValue;
              }
            }
          });
        }

        // Method 3: Fallback to variant title parsing
        if (
          !color &&
          !size &&
          item.variant_title &&
          item.variant_title !== "Default Title"
        ) {
          const variantParts = item.variant_title.split(" / ");
          if (variantParts.length >= 2) {
            color = variantParts[0].trim();
            size = variantParts[1].trim();
          } else if (variantParts.length === 1) {
            const value = variantParts[0].trim();
            const colorKeywords = [
              "black",
              "white",
              "grey",
              "gray",
              "navy",
              "blue",
              "red",
              "green",
              "brown",
              "beige",
              "tan",
              "yellow",
              "orange",
              "pink",
              "purple",
              "leather",
              "suede",
            ];
            if (
              colorKeywords.some((keyword) =>
                value.toLowerCase().includes(keyword),
              )
            ) {
              color = value;
            } else {
              size = value;
            }
          }
        }

        // Method 4: Check item.variant properties (nested structure)
        if ((!color || !size) && item.variant) {
          if (item.variant.option1 && !color) {
            const opt1 = item.variant.option1;
            const colorKeywords = [
              "black",
              "white",
              "grey",
              "gray",
              "navy",
              "blue",
              "red",
              "green",
              "brown",
              "beige",
              "tan",
              "yellow",
              "orange",
              "pink",
              "purple",
              "leather",
              "suede",
            ];
            if (
              colorKeywords.some((keyword) =>
                opt1.toLowerCase().includes(keyword),
              )
            ) {
              color = opt1;
            } else if (!size) {
              size = opt1;
            }
          }
          if (item.variant.option2 && !size) {
            const opt2 = item.variant.option2;
            const sizeKeywords = [
              "xs",
              "sm",
              "s",
              "m",
              "l",
              "xl",
              "xxl",
              "xxxl",
              "2xl",
              "3xl",
              "small",
              "medium",
              "large",
            ];
            if (
              sizeKeywords.some(
                (keyword) =>
                  opt2.toLowerCase() === keyword ||
                  opt2.toLowerCase().includes(keyword),
              ) ||
              /^\d/.test(opt2)
            ) {
              size = opt2;
            } else if (!color) {
              color = opt2;
            }
          }
        }

        // Method 5: Check properties for color/size
        if (item.properties && Object.keys(item.properties).length > 0) {
          Object.keys(item.properties).forEach((key) => {
            const lowerKey = key.toLowerCase();
            const value = item.properties[key];
            if (lowerKey.includes("color") && !color && value) {
              color = value;
            }
            if (lowerKey.includes("size") && !size && value) {
              size = value;
            }
          });
        }

        // Debug logging
        console.log("Cart item variant info:", {
          variant_options: item.variant_options,
          options_with_values: item.options_with_values,
          variant_title: item.variant_title,
          extracted_color: color,
          extracted_size: size,
        });

        // Handle image URL - Shopify cart API returns image as a URL string
        // The image might be a full URL or a relative path
        let imageUrl = "";
        if (item.image) {
          if (typeof item.image === "string") {
            // Handle protocol-relative URLs (//cdn.shopify.com/...)
            if (item.image.startsWith("//")) {
              imageUrl = `https:${item.image}`;
            }
            // Handle absolute URLs
            else if (
              item.image.startsWith("http://") ||
              item.image.startsWith("https://")
            ) {
              imageUrl = item.image;
            }
            // Handle relative URLs - prepend shop domain
            else if (item.image.startsWith("/")) {
              imageUrl = window.shopUrl + item.image;
            }
            // Otherwise use as-is
            else {
              imageUrl = item.image;
            }
          }
          // If image is an object with url property
          else if (item.image.url) {
            const url = item.image.url;
            if (url.startsWith("//")) {
              imageUrl = `https:${url}`;
            } else if (
              url.startsWith("http://") ||
              url.startsWith("https://")
            ) {
              imageUrl = url;
            } else if (url.startsWith("/")) {
              imageUrl = window.shopUrl + url;
            } else {
              imageUrl = url;
            }
          }
        }

        // Fallback: try featured_image or product image
        if (!imageUrl) {
          const fallbackImage =
            item.featured_image ||
            (item.product && item.product.featured_image);
          if (fallbackImage) {
            if (typeof fallbackImage === "string") {
              imageUrl = fallbackImage.startsWith("//")
                ? `https:${fallbackImage}`
                : fallbackImage.startsWith("/")
                  ? window.shopUrl + fallbackImage
                  : fallbackImage;
            }
          }
        }

        // Use the global escapeHtml function (defined above)
        const productTitle = escapeHtml(
          item.product ? item.product.title : item.title,
        );
        // Remove variant info from title if it exists
        const cleanTitle = productTitle.replace(/ - [^-]*$/, "");
        const itemUrl =
          item.url || (item.product ? `/products/${item.product.handle}` : "#");
        const colorText = color ? escapeHtml(color) : "";
        const sizeText = size ? escapeHtml(size) : "";

        return `
        <div class="cart-sidebar-item" data-cart-item-id="${item.key}">
          <div class="cart-sidebar-item__image-wrapper">
            ${
              imageUrl
                ? `<img 
              src="${escapeHtml(imageUrl)}" 
              alt="${escapeHtml(item.title || productTitle)}" 
              class="cart-sidebar-item__image"
              onerror="this.onerror=null; this.style.display='none'; this.parentElement.innerHTML='<div class=\\'cart-sidebar-item__image\\' style=\\'background: #f5f5f5;\\'></div>';"
            >`
                : '<div class="cart-sidebar-item__image" style="background: #f5f5f5;"></div>'
            }
            <button type="button" class="cart-sidebar-item__wishlist" aria-label="Add to wishlist">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
              </svg>
            </button>
          </div>
          <div class="cart-sidebar-item__details">
            <div class="cart-sidebar-item__info">
              <h3 class="cart-sidebar-item__title">
                <a href="${escapeHtml(itemUrl)}">${cleanTitle}</a>
              </h3>
              ${
                colorText || sizeText
                  ? `<div class="cart-sidebar-item__variant-info">
                ${colorText ? `<div class="cart-sidebar-item__variant">Color: <span class="cart-sidebar-item__variant-value">${colorText}</span></div>` : ""}
                ${sizeText ? `<div class="cart-sidebar-item__variant">Size: <span class="cart-sidebar-item__variant-value">${sizeText}</span></div>` : ""}
              </div>`
                  : ""
              }
              <div class="cart-sidebar-item__quantity">
                <button type="button" class="cart-sidebar-item__quantity-btn" data-cart-quantity-decrease="${item.key}">−</button>
                <input 
                  type="number" 
                  class="cart-sidebar-item__quantity-input" 
                  value="${item.quantity}" 
                  min="1"
                  data-cart-quantity-input
                  readonly
                >
                <button type="button" class="cart-sidebar-item__quantity-btn" data-cart-quantity-increase="${item.key}">+</button>
              </div>
            </div>
            <div class="cart-sidebar-item__pricing">
              <button type="button" class="cart-sidebar-item__remove" data-cart-remove="${item.key}" aria-label="Remove item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                </svg>
              </button>
              <div class="cart-sidebar-item__price-info">
                <div class="cart-sidebar-item__unit-price">Unit Price</div>
                <div class="cart-sidebar-item__unit-price-value">${unitPrice}</div>
                <div class="cart-sidebar-item__total-label">Total</div>
                <div class="cart-sidebar-item__total-price">${totalPrice}</div>
              </div>
            </div>
          </div>
        </div>
      `;
      })
      .join("");

    console.log("Cart items rendered successfully");
  } catch (renderError) {
    console.error("Error rendering cart items:", renderError);
    itemsContainer.innerHTML =
      '<p style="padding: 2rem; text-align: center; color: #999;">Error displaying cart items. Please refresh the page.</p>';
  }
}

function updateCartSubtotal(cart) {
  if (!cart) return;

  const totalPrice = cart.total_price || 0;
  const formattedTotal = formatMoney(totalPrice);

  // Update all total elements
  const subtotalEl = document.querySelector("[data-cart-sidebar-subtotal]");
  const totalEl = document.querySelector("[data-cart-sidebar-total]");

  if (subtotalEl) subtotalEl.textContent = formattedTotal;
  if (totalEl) totalEl.textContent = formattedTotal;

  updateDynamicCheckoutButtons(cart);
}

function updateDynamicCheckoutButtons(cart) {
  const dynamicCheckoutContainer = document.querySelector(
    "[data-cart-sidebar-dynamic-checkout]",
  );
  if (!dynamicCheckoutContainer) return;

  if (cart.item_count === 0) {
    dynamicCheckoutContainer.innerHTML = "";
    return;
  }

  // Create form structure for Shopify dynamic checkout
  // Shopify's dynamic checkout buttons require a form with cart items
  let formHTML =
    '<form action="' +
    window.routes.cart_url +
    '" method="post" class="cart-sidebar__dynamic-form">';

  // Add hidden inputs for each cart item (required for dynamic checkout)
  cart.items.forEach((item) => {
    formHTML +=
      '<input type="hidden" name="updates[' +
      escapeHtml(item.key) +
      ']" value="' +
      item.quantity +
      '">';
  });

  formHTML += '<div class="dynamic-checkout__content"></div></form>';

  dynamicCheckoutContainer.innerHTML = formHTML;

  // Initialize Shopify dynamic checkout buttons
  // This will automatically detect and render available express checkout options
  if (typeof Shopify !== "undefined") {
    // Wait a bit for DOM to update, then initialize
    setTimeout(() => {
      const form = dynamicCheckoutContainer.querySelector("form");
      const container = dynamicCheckoutContainer.querySelector(
        ".dynamic-checkout__content",
      );

      if (form && container) {
        // Use Shopify's dynamic checkout button API
        if (Shopify.dynamicPaymentButtons) {
          Shopify.dynamicPaymentButtons.init();
        }

        // Alternative: Create dynamic checkout button manually
        // Fetch checkout button HTML from cart page
        fetch(window.routes.cart_url)
          .then((response) => response.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            // Look for dynamic checkout button container
            const checkoutButtons = doc.querySelector(
              '[data-shopify="dynamic-checkout"], .dynamic-checkout__content, .shopify-payment-button',
            );

            if (checkoutButtons) {
              container.innerHTML = checkoutButtons.innerHTML;

              // Re-execute any scripts in the loaded HTML
              const scripts = container.querySelectorAll("script");
              scripts.forEach((oldScript) => {
                const newScript = document.createElement("script");
                Array.from(oldScript.attributes).forEach((attr) => {
                  newScript.setAttribute(attr.name, attr.value);
                });
                newScript.textContent = oldScript.textContent;
                oldScript.parentNode.replaceChild(newScript, oldScript);
              });

              // Reinitialize payment buttons
              if (
                typeof Shopify !== "undefined" &&
                Shopify.dynamicPaymentButtons
              ) {
                Shopify.dynamicPaymentButtons.init();
              }
            }
          })
          .catch((error) => {
            console.error("Error loading dynamic checkout buttons:", error);
          });
      }
    }, 100);
  }
}

function updateCartItemQuantity(key, quantity) {
  const sidebar = document.querySelector("[data-cart-sidebar]");
  const cartItem = sidebar
    ? sidebar.querySelector(`[data-cart-item-key="${key}"]`)
    : null;

  if (!cartItem) return;

  const minusBtn = cartItem.querySelector("[data-cart-quantity-minus]");
  const plusBtn = cartItem.querySelector("[data-cart-quantity-plus]");
  const removeBtn = cartItem.querySelector("[data-cart-remove]");
  const input = cartItem.querySelector("[data-cart-quantity-input]");

  // Disable buttons immediately
  if (minusBtn) minusBtn.disabled = true;
  if (plusBtn) plusBtn.disabled = true;
  if (removeBtn) removeBtn.disabled = true;

  // Show loading
  let overlay = cartItem.querySelector(".cart-sidebar-item__loading");
  if (!overlay) {
    overlay = document.createElement("div");
    overlay.className = "cart-sidebar-item__loading";
    overlay.innerHTML =
      '<div class="cart-sidebar-item__loading-spinner"></div>';
    cartItem.appendChild(overlay);
  }
  overlay.classList.add("is-visible");

  // Set timeout to prevent infinite loading
  const timeout = setTimeout(() => {
    overlay.classList.remove("is-visible");
    if (minusBtn) minusBtn.disabled = false;
    if (plusBtn) plusBtn.disabled = false;
    if (removeBtn) removeBtn.disabled = false;
  }, 5000);

  const updates = {};
  updates[key] = quantity;

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates }),
  })
    .then((response) => {
      clearTimeout(timeout);
      if (!response.ok) throw new Error("Update failed");
      return response.json();
    })
    .then((cart) => {
      overlay.classList.remove("is-visible");

      if (quantity === 0) {
        cartItem.remove();
        if (cart.item_count === 0) {
          const emptyContainer = sidebar.querySelector(
            "[data-cart-sidebar-empty]",
          );
          if (emptyContainer) emptyContainer.style.display = "flex";
        }
      } else {
        if (input) input.value = quantity;
        const updatedItem = cart.items.find((item) => item.key === key);
        if (updatedItem) {
          const totalPriceEl = cartItem.querySelector(
            ".cart-sidebar-item__total-price",
          );
          if (totalPriceEl) {
            totalPriceEl.textContent = formatMoney(updatedItem.line_price);
          }
        }
      }

      // Update ORDER OVERVIEW totals immediately
      const subtotalEl = document.querySelector("[data-cart-sidebar-subtotal]");
      const totalEl = document.querySelector("[data-cart-sidebar-total]");
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

      updateCartCount();

      if (minusBtn) minusBtn.disabled = false;
      if (plusBtn) plusBtn.disabled = false;
      if (removeBtn) removeBtn.disabled = false;
    })
    .catch((error) => {
      clearTimeout(timeout);
      overlay.classList.remove("is-visible");
      console.error("Cart update failed:", error);

      if (minusBtn) minusBtn.disabled = false;
      if (plusBtn) plusBtn.disabled = false;
      if (removeBtn) removeBtn.disabled = false;

      // Reload cart and update totals on error
      setTimeout(() => {
        loadCartSidebar();
        fetch("/cart.js")
          .then((r) => r.json())
          .then((cart) => {
            const subtotalEl = document.querySelector(
              "[data-cart-sidebar-subtotal]",
            );
            const totalEl = document.querySelector("[data-cart-sidebar-total]");
            if (subtotalEl)
              subtotalEl.textContent = formatMoney(cart.total_price);
            if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
          });
      }, 500);
    });
}

function removeCartItem(key) {
  updateCartItemQuantity(key, 0);
}

/* Cart Loading Overlay */
function showCartLoadingOverlay() {
  // Simple implementation - could be enhanced with actual overlay
  console.log("Cart loading...");
}

function hideCartLoadingOverlay() {
  // Simple implementation - could be enhanced with actual overlay
  console.log("Cart loading complete");
}

/* Add to Cart Success Overlay */
function showAddToCartSuccess() {
  // Simple implementation - could be enhanced with success message
  console.log("Item added to cart successfully");
}

/* Utility: Slide out animation */
const styleSheet = document.createElement("style");
styleSheet.textContent = `
    @keyframes slideOutRight {
      from {
        opacity: 1;
        transform: translateX(0);
      }
      to {
        opacity: 0;
        transform: translateX(100%);
      }
    }
  `;
document.head.appendChild(styleSheet);

/* Product Variant Selection */
document.addEventListener("change", function (e) {
  if (!e.target.matches("[data-option-select]")) return;

  console.log("=== Variant Selection Handler Triggered ===");
  console.log("Select element:", e.target.id, "Value:", e.target.value);

  const productJson = document.getElementById("ProductJson");
  if (!productJson) {
    console.error("ProductJson not found!");
    return;
  }

  const product = JSON.parse(productJson.textContent);
  const form = e.target.closest("form");
  const selects = form.querySelectorAll("[data-option-select]");

  console.log("Found", selects.length, "select elements");

  // Get selected options - build full options array including color from current variant
  const currentVariantId = form.querySelector("[data-variant-id]")?.value;
  const currentVariant = product.variants.find((v) => v.id == currentVariantId);

  const selectedOptions = [];

  // Determine which option is missing (Color vs Size)
  // If we have fewer selects than product options, we need to get the missing option from current variant
  if (currentVariant && selects.length < product.options.length) {
    // Find which option index is NOT represented by a select
    const selectNames = Array.from(selects).map((s) =>
      s.name.replace("options[", "").replace("]", ""),
    );

    product.options.forEach((option, index) => {
      const optionName = typeof option === "string" ? option : option.name;
      if (selectNames.includes(optionName)) {
        // This option has a select - use its value
        const select = form.querySelector(
          `select[name="options[${optionName}]"]`,
        );
        if (select) selectedOptions[index] = select.value;
      } else {
        // This option doesn't have a select - use current variant's value
        selectedOptions[index] = currentVariant.options[index];
      }
    });
  } else {
    // Normal case - all options have selects
    selects.forEach((select) => {
      selectedOptions.push(select.value);
    });
  }

  console.log("Select:", e.target.id, "Value:", e.target.value);
  console.log("Selected options:", selectedOptions);

  // Find matching variant
  const variant = product.variants.find((v) => {
    const matches = v.options.every(
      (option, index) => option === selectedOptions[index],
    );
    if (matches) {
      console.log("Found matching variant:", v.id, "Options:", v.options);
    }
    return matches;
  });

  if (variant) {
    console.log("Variant found:", variant.id, "Color:", variant.option1);
    // Update variant ID
    const variantInput = form.querySelector("[data-variant-id]");
    if (variantInput) variantInput.value = variant.id;

    // Update price
    const priceEl = document.querySelector("[data-product-price]");
    if (priceEl) {
      // Use Liquid money filter format for consistency
      const formattedPrice = formatMoney(variant.price);

      if (variant.compare_at_price > variant.price) {
        const formattedCompare = formatMoney(variant.compare_at_price);
        priceEl.innerHTML = `
            <span class="product-info__price--compare">${formattedCompare}</span>
            <span class="product-info__price--sale">${formattedPrice}</span>
          `;
      } else {
        priceEl.innerHTML = `<span class="product-info__price--sale">${formattedPrice}</span>`;
      }
    }

    // Update button state - use setTimeout to run after Rubik app
    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      // Check availability - default to true if property doesn't exist
      const isAvailable = variant.available !== false;
      console.log(
        "Variant availability:",
        variant.available,
        "isAvailable:",
        isAvailable,
      );

      // Immediate update
      submitBtn.disabled = !isAvailable;
      submitBtn.textContent = isAvailable ? "ADD TO CART" : "SOLD OUT";

      // Delayed update to override any app that might change it
      setTimeout(() => {
        submitBtn.disabled = !isAvailable;
        submitBtn.textContent = isAvailable ? "ADD TO CART" : "SOLD OUT";
      }, 100);
    }

    // Keep option labels static; the selected value is already shown in the selector UI
    selects.forEach((select) => {
      const optionName = select.name.replace("options[", "").replace("]", "");
      const label = form.querySelector(`label[for="${select.id}"]`);
      if (label) {
        label.textContent = optionName.toUpperCase() + ":";
      }
    });

    // Update images based on variant
    console.log("Variant selected:", variant.id, "Options:", variant.options);
    updateProductImages(variant, product);

    // Update URL
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variant.id);
    window.history.replaceState({}, "", url);
  } else {
    console.error("No matching variant found for options:", selectedOptions);
    console.log(
      "Available variants:",
      product.variants.map((v) => ({
        id: v.id,
        options: v.options,
        available: v.available,
      })),
    );

    // Try to find an available variant with the same first option (color)
    const colorOption = selectedOptions[0];
    const fallbackVariant = product.variants.find(
      (v) => v.options[0] === colorOption && v.available !== false,
    );

    if (fallbackVariant) {
      console.log(
        "Found fallback variant with same color:",
        fallbackVariant.id,
      );
      // Update the size select to match the fallback variant
      if (fallbackVariant.options[1]) {
        const sizeSelect = form.querySelector('select[name="options[Size]"]');
        if (sizeSelect) {
          sizeSelect.value = fallbackVariant.options[1];
        }
      }
      // Update variant ID
      const variantInput = form.querySelector("[data-variant-id]");
      if (variantInput) variantInput.value = fallbackVariant.id;

      // Enable button
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = "ADD TO CART";
      }
    } else {
      // No available variant for this color - disable button
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = "UNAVAILABLE";
      }
    }
  }
});

/* Update Product Images Based on Variant */
function updateProductImages(variant, product) {
  if (!variant || !product) {
    console.log("updateProductImages: Missing variant or product", {
      variant,
      product,
    });
    return;
  }

  console.log("=== updateProductImages START ===");
  console.log("Variant ID:", variant.id);
  console.log("Variant option1 (Color):", variant.option1);

  // Try to get variant images from our custom JSON data
  const variantImagesJson = document.getElementById("VariantImagesJson");
  let variantImageUrl = null;
  let colorHandle = null;

  if (variantImagesJson) {
    try {
      const variantImagesData = JSON.parse(variantImagesJson.textContent);
      const variantData = variantImagesData[variant.id];
      console.log("Variant data from JSON:", variantData);

      if (variantData) {
        variantImageUrl = variantData.featured_image;
        colorHandle = variantData.color;
        console.log("Found variant image URL:", variantImageUrl);
        console.log("Color handle:", colorHandle);
      }
    } catch (e) {
      console.error("Error parsing VariantImagesJson:", e);
    }
  }

  // If we have a featured image URL, update the gallery
  if (variantImageUrl) {
    console.log("Updating images with featured_image:", variantImageUrl);

    // Update desktop gallery (first image)
    const desktopImages = document.querySelectorAll(
      ".product-gallery__images .product-gallery__image img",
    );
    if (desktopImages.length > 0) {
      desktopImages[0].src = variantImageUrl.replace("1200x", "800x");
      console.log("Updated desktop image 0");
    }

    // Update mobile carousel (first slide)
    const carouselImages = document.querySelectorAll(
      "[data-carousel-slide] img",
    );
    if (carouselImages.length > 0) {
      carouselImages[0].src = variantImageUrl;
      console.log("Updated carousel image 0");

      // Reset carousel to first slide
      const track = document.querySelector("[data-carousel-track]");
      if (track) {
        track.style.transform = "translateX(0%)";
      }
      const currentSpan = document.querySelector("[data-carousel-current]");
      if (currentSpan) currentSpan.textContent = "1";
      const dots = document.querySelectorAll("[data-carousel-dot]");
      dots.forEach((dot, i) => dot.classList.toggle("is-active", i === 0));
    }

    return;
  }

  // Don't swap images - just keep them in original order
  // Images should remain static regardless of size selection
  console.log("Keeping images in original order - no swapping on size change");

  console.log("=== updateProductImages END ===");
}

/* Welcome Section Carousel */
function initWelcomeCarousel() {
  const carousel = document.querySelector("[data-carousel]");
  if (!carousel) return;

  // Find the wrapper that contains both carousel and navigation buttons
  const wrapper = carousel.closest(".welcome-section__carousel-wrapper");
  if (!wrapper) return;

  const track = carousel.querySelector("[data-carousel-track]");
  const prevBtn = wrapper.querySelector("[data-carousel-prev]");
  const nextBtn = wrapper.querySelector("[data-carousel-next]");
  const genderFilters = document.querySelectorAll("[data-gender-filter]");

  if (!track || !prevBtn || !nextBtn) return;

  let currentIndex = 0;
  let currentGender = "men";
  let visibleCards = [];

  function getCardWidth() {
    const visibleCard =
      visibleCards.length > 0
        ? visibleCards[0]
        : track.querySelector(
            '.welcome-section__category-card:not([style*="display: none"])',
          );
    if (!visibleCard) return 0;
    const style = window.getComputedStyle(visibleCard);
    const width = visibleCard.offsetWidth;
    const gap = parseInt(style.marginRight) || parseInt(style.marginLeft) || 16;
    return width + gap;
  }

  function getMaxVisible() {
    const isMobile = window.innerWidth < 768;
    return isMobile
      ? 1
      : Math.max(
          1,
          Math.floor(carousel.offsetWidth / Math.max(1, getCardWidth())),
        );
  }

  function getMaxIndex() {
    const visibleCount = visibleCards.length;
    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      return Math.max(0, visibleCount - 1);
    } else {
      const containerWidth = carousel.offsetWidth;
      const cardWidth = getCardWidth();
      if (cardWidth === 0) return 0;

      const visibleCards = Math.floor(containerWidth / cardWidth);
      return Math.max(0, visibleCount - visibleCards);
    }
  }

  function filterByGender(gender) {
    currentGender = gender;
    const allCards = Array.from(
      track.querySelectorAll(".welcome-section__category-card"),
    );
    visibleCards = [];

    // Normalize gender value (lowercase, trimmed)
    const normalizedGender = (gender || "men").toLowerCase().trim();

    // Add fade out effect
    allCards.forEach((card) => {
      card.style.transition = "opacity 0.3s ease";
      card.style.opacity = "0";
    });

    setTimeout(() => {
      allCards.forEach((card) => {
        // Normalize card gender value (lowercase, trimmed)
        const cardGender = (card.getAttribute("data-gender") || "men")
          .toLowerCase()
          .trim();

        // Show card if it matches the selected gender or is set to 'both'
        if (cardGender === normalizedGender || cardGender === "both") {
          card.style.display = "";
          visibleCards.push(card);
          // Fade in with delay
          setTimeout(() => {
            card.style.opacity = "1";
          }, 50);
        } else {
          card.style.display = "none";
          card.style.opacity = "0";
        }
      });

      // Reset carousel position
      currentIndex = 0;
      updateCarousel();
    }, 150);
  }

  function updateCarousel() {
    const cardWidth = getCardWidth();
    if (cardWidth === 0) return; // Don't update if card width is 0

    const translateX = -currentIndex * cardWidth;
    track.style.transform = `translateX(${translateX}px)`;

    const maxIndex = getMaxIndex();

    // Update button states
    prevBtn.disabled = currentIndex === 0;
    nextBtn.disabled = currentIndex >= maxIndex;
  }

  // Gender filter buttons
  genderFilters.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      const gender = (this.getAttribute("data-gender-filter") || "men")
        .toLowerCase()
        .trim();

      // Update active state
      genderFilters.forEach((b) => b.classList.remove("is-active"));
      this.classList.add("is-active");

      // Filter categories
      filterByGender(gender);
    });
  });

  // Carousel navigation
  prevBtn.addEventListener("click", function () {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  });

  nextBtn.addEventListener("click", function () {
    const maxIndex = getMaxIndex();

    if (currentIndex < maxIndex) {
      currentIndex++;
      updateCarousel();
    }
  });

  // Handle window resize
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      // Recalculate card width and reset if needed
      const newCardWidth = getCardWidth();
      if (newCardWidth > 0) {
        // Ensure currentIndex is still valid
        const maxIndex = getMaxIndex();
        currentIndex = Math.min(currentIndex, maxIndex);
      }
      updateCarousel();
    }, 250);
  });

  // Touch/Drag functionality for mobile - decreased friction for snappier scrolling
  let touchStartX = 0;
  let isDragging = false;
  let startTransform = 0;
  let lastTouchX = 0;
  let lastTouchTime = 0;

  function handleTouchStart(e) {
    touchStartX = e.touches[0].clientX;
    lastTouchX = touchStartX;
    lastTouchTime = Date.now();
    isDragging = false;

    // Get current transform value
    const transform = track.style.transform;
    const match = transform.match(/translateX\(([^)]+)px\)/);
    startTransform = match ? parseFloat(match[1]) : 0;

    // Disable transition during drag
    track.style.transition = "none";
  }

  function handleTouchMove(e) {
    if (!touchStartX) return;

    const touchCurrentX = e.touches[0].clientX;
    const deltaX = touchCurrentX - touchStartX;

    // Start dragging on any horizontal movement
    if (!isDragging && Math.abs(deltaX) > 5) {
      isDragging = true;
      e.preventDefault();
    }

    if (isDragging) {
      e.preventDefault();
      lastTouchX = touchCurrentX;
      lastTouchTime = Date.now();

      const newTransform = startTransform + deltaX;

      // Calculate boundaries - restrict to last card
      const cardWidth = getCardWidth();
      const maxIndex = getMaxIndex();
      const minTransform = -(maxIndex * cardWidth);
      const maxTransform = 0;

      // Constrain transform within boundaries
      const constrainedTransform = Math.max(
        minTransform,
        Math.min(maxTransform, newTransform),
      );
      track.style.transform = `translateX(${constrainedTransform}px)`;
    }
  }

  function handleTouchEnd(e) {
    if (!isDragging) {
      touchStartX = 0;
      isDragging = false;
      return;
    }

    // Re-enable transition with faster animation
    track.style.transition =
      "transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)";

    // Calculate velocity for momentum
    const touchEndX = e.changedTouches[0].clientX;
    const timeDiff = Date.now() - lastTouchTime;
    const velocity = (lastTouchX - touchEndX) / timeDiff;

    // Get card width and snap to nearest card
    const cardWidth = getCardWidth();
    const maxIndex = getMaxIndex();

    // Calculate current position
    const transform = track.style.transform;
    const match = transform.match(/translateX\(([^)]+)px\)/);
    const currentTransform = match ? parseFloat(match[1]) : 0;
    let targetIndex = Math.round(-currentTransform / cardWidth);

    // Apply momentum if velocity is significant
    if (Math.abs(velocity) > 0.3) {
      // High velocity - move multiple cards
      targetIndex = velocity > 0 ? targetIndex + 1 : targetIndex - 1;
    }

    // Constrain target index to prevent infinite scrolling
    targetIndex = Math.max(0, Math.min(targetIndex, maxIndex));

    // Update carousel to target position
    currentIndex = targetIndex;
    updateCarousel();

    // Reset
    touchStartX = 0;
    isDragging = false;
  }

  // Add touch event listeners to carousel
  carousel.addEventListener("touchstart", handleTouchStart, { passive: true });
  carousel.addEventListener("touchmove", handleTouchMove, { passive: false });
  carousel.addEventListener("touchend", handleTouchEnd, { passive: true });

  // Initialize with men's categories
  filterByGender("men");
}

/* Hand-Picked Section Carousel */
function initHandPickedCarousel() {
  const carousel = document.querySelector("[data-handpicked-carousel]");
  if (!carousel) return;

  // Find the wrapper that contains both carousel and navigation buttons
  const wrapper = carousel.closest(".hand-picked-section__carousel-wrapper");
  if (!wrapper) return;

  const tracks = carousel.querySelectorAll("[data-handpicked-track]");
  const prevBtn = wrapper.querySelector("[data-handpicked-prev]");
  const nextBtn = wrapper.querySelector("[data-handpicked-next]");
  const genderFilters = document.querySelectorAll("[data-handpicked-gender]");

  if (!tracks.length || !prevBtn || !nextBtn) return;

  let currentIndex = 0;
  let currentGender = "men";
  let currentTrack = null;
  let visibleProducts = [];

  function getProductWidth() {
    if (!currentTrack) return 0;
    // Use the base width (non-center product) for calculations
    const firstProduct = currentTrack.querySelector(
      ".hand-picked-section__product:not(.is-center)",
    );
    if (!firstProduct) {
      const anyProduct = currentTrack.querySelector(
        ".hand-picked-section__product",
      );
      if (!anyProduct) return 0;
      // If all are center, use center width
      const style = window.getComputedStyle(anyProduct);
      const width = anyProduct.offsetWidth;
      const gap = parseInt(style.marginRight) || 32;
      return width + gap;
    }
    const style = window.getComputedStyle(firstProduct);
    const width = firstProduct.offsetWidth;
    const gap = parseInt(style.marginRight) || 32;
    return width + gap;
  }

  function filterByGender(gender) {
    currentGender = gender;

    // Find and show the appropriate track
    tracks.forEach((track) => {
      const trackGender = track.getAttribute("data-gender");
      if (trackGender === gender) {
        track.style.display = "";
        currentTrack = track;
      } else {
        track.style.display = "none";
      }
    });

    if (!currentTrack) return;

    // Get all products from the visible track
    visibleProducts = Array.from(
      currentTrack.querySelectorAll(".hand-picked-section__product"),
    );

    currentIndex = 0;
    setTimeout(() => {
      updateCarousel();
    }, 50);
  }

  function updateCarousel() {
    if (!currentTrack) return;

    // Remove center class from all products
    visibleProducts.forEach((product) => {
      product.classList.remove("is-center");
    });

    // Add center class to the middle product (index 2 in a 5-product view)
    // When showing 5 products, the center is always at index 2
    const centerIndex = 2;
    if (visibleProducts[centerIndex] && visibleProducts.length >= 5) {
      visibleProducts[centerIndex].classList.add("is-center");
    } else if (visibleProducts.length < 5 && visibleProducts.length > 0) {
      // If less than 5 products, center the middle one
      const midIndex = Math.floor(visibleProducts.length / 2);
      if (visibleProducts[midIndex]) {
        visibleProducts[midIndex].classList.add("is-center");
      }
    }

    const productWidth = getProductWidth();
    const translateX = -currentIndex * productWidth;
    currentTrack.style.transform = `translateX(${translateX}px)`;

    const visibleCount = visibleProducts.length;
    const maxVisible = Math.min(5, visibleCount);

    prevBtn.disabled = currentIndex === 0;
    nextBtn.disabled = currentIndex >= Math.max(0, visibleCount - maxVisible);
  }

  // Gender filter buttons
  genderFilters.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      const gender = this.getAttribute("data-handpicked-gender");

      genderFilters.forEach((b) => b.classList.remove("is-active"));
      this.classList.add("is-active");

      filterByGender(gender);
    });
  });

  // Carousel navigation
  prevBtn.addEventListener("click", function () {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  });

  nextBtn.addEventListener("click", function () {
    const visibleCount = visibleProducts.length;
    const maxVisible = Math.min(5, visibleCount);
    const maxIndex = Math.max(0, visibleCount - maxVisible);

    if (currentIndex < maxIndex) {
      currentIndex++;
      updateCarousel();
    }
  });

  // Handle window resize
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      updateCarousel();
    }, 250);
  });

  // Initialize with men's products
  filterByGender("men");

  // Set initial center product
  setTimeout(() => {
    updateCarousel();
  }, 100);
}

/* Color Collection Carousel */
function initColorCollectionCarousel() {
  const carousel = document.querySelector("[data-color-carousel]");
  if (!carousel) return;

  // Find the section that contains both carousel and navigation buttons
  const section = carousel.closest(".color-collection-section");
  if (!section) return;

  const track = carousel.querySelector("[data-color-track]");
  const prevBtn = section.querySelector("[data-color-prev]");
  const nextBtn = section.querySelector("[data-color-next]");

  if (!track || !prevBtn || !nextBtn) return;

  let currentIndex = 0;
  const cards = Array.from(
    track.querySelectorAll(".color-collection-section__card"),
  );
  const totalCards = cards.length;

  function getVisibleCards() {
    // On mobile, typically 1 card is visible, on desktop 3-5 cards
    const isMobile = window.innerWidth < 768;
    return isMobile ? 1 : 5;
  }

  function getCardWidth() {
    const firstCard = cards[0];
    if (!firstCard) return 0;
    const style = window.getComputedStyle(firstCard);
    const width = firstCard.offsetWidth;
    const gap = parseInt(style.marginRight) || parseInt(style.marginLeft) || 16;
    return width + gap;
  }

  function updateCarousel() {
    const cardWidth = getCardWidth();
    if (cardWidth === 0) return; // Don't update if card width is 0

    const translateX = -currentIndex * cardWidth;
    track.style.transform = `translateX(${translateX}px)`;

    const visibleCards = getVisibleCards();
    // On mobile, allow scrolling to the last card (totalCards - 1)
    // On desktop, stop when last visibleCards are shown
    const isMobile = window.innerWidth < 768;
    const maxIndex = isMobile
      ? Math.max(0, totalCards - 1)
      : Math.max(0, totalCards - visibleCards);

    prevBtn.disabled = currentIndex === 0;
    nextBtn.disabled = currentIndex >= maxIndex;
  }

  prevBtn.addEventListener("click", function () {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  });

  nextBtn.addEventListener("click", function () {
    const visibleCards = getVisibleCards();
    const isMobile = window.innerWidth < 768;
    const maxIndex = isMobile
      ? Math.max(0, totalCards - 1)
      : Math.max(0, totalCards - visibleCards);

    if (currentIndex < maxIndex) {
      currentIndex++;
      updateCarousel();
    }
  });

  // Handle window resize
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      // Recalculate card width
      const newCardWidth = getCardWidth();
      if (newCardWidth > 0) {
        // Ensure currentIndex is still valid after resize
        const visibleCards = getVisibleCards();
        const isMobile = window.innerWidth < 768;
        const maxIndex = isMobile
          ? Math.max(0, totalCards - 1)
          : Math.max(0, totalCards - visibleCards);
        currentIndex = Math.min(currentIndex, maxIndex);
      }
      updateCarousel();
    }, 250);
  });

  let touchStartX = 0;
  let touchStartY = 0;
  let touchEndX = 0;
  let touchEndY = 0;
  let isDragging = false;
  let startTransform = 0;

  function handleTouchStart(e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    isDragging = false;

    // Get current transform value
    const transform = track.style.transform;
    const match = transform.match(/translateX\(([^)]+)px\)/);
    startTransform = match ? parseFloat(match[1]) : 0;

    // Disable transition during drag
    track.style.transition = "none";
  }

  function handleTouchMove(e) {
    if (!touchStartX || !touchStartY) return;

    const touchCurrentX = e.touches[0].clientX;
    const deltaX = touchCurrentX - touchStartX;

    // Start dragging on any horizontal movement
    if (!isDragging && Math.abs(deltaX) > 5) {
      isDragging = true;
      e.preventDefault();
    }

    if (isDragging) {
      e.preventDefault();
      const newTransform = startTransform + deltaX;

      // Calculate boundaries
      const cardWidth = getCardWidth();
      const visibleCards = getVisibleCards();
      const isMobile = window.innerWidth < 768;
      const maxIndex = isMobile
        ? Math.max(0, totalCards - 1)
        : Math.max(0, totalCards - visibleCards);
      const minTransform = -(maxIndex * cardWidth);
      const maxTransform = 0;

      // Constrain transform within boundaries
      const constrainedTransform = Math.max(
        minTransform,
        Math.min(maxTransform, newTransform),
      );
      track.style.transform = `translateX(${constrainedTransform}px)`;
    }
  }

  function handleTouchEnd(e) {
    // Re-enable transition
    track.style.transition = "";

    // Reset without any adjustment
    touchStartX = 0;
    touchStartY = 0;
    touchEndX = 0;
    touchEndY = 0;
    isDragging = false;
  }

  // Add touch event listeners to carousel
  carousel.addEventListener("touchstart", handleTouchStart, { passive: true });
  carousel.addEventListener("touchmove", handleTouchMove, { passive: false });
  carousel.addEventListener("touchend", handleTouchEnd, { passive: true });

  // Initialize
  updateCarousel();
}

/* Wishlist Functionality */
function initWishlist() {
  // Get wishlist from localStorage (new format with full product data)
  function getWishlist() {
    try {
      const wishlist = localStorage.getItem("wishlist-storage");
      if (wishlist) {
        const parsed = JSON.parse(wishlist);
        return parsed.state?.items || [];
      }
      // Fallback to old format (just IDs)
      const oldWishlist = localStorage.getItem("wishlist");
      if (oldWishlist) {
        const ids = JSON.parse(oldWishlist);
        return ids.map((id) => ({ id: String(id) }));
      }
      return [];
    } catch (e) {
      return [];
    }
  }

  // Save wishlist to localStorage
  function saveWishlist(items) {
    try {
      const wishlistData = {
        state: { items: items },
        version: 0,
      };
      localStorage.setItem("wishlist-storage", JSON.stringify(wishlistData));
      // Also keep old format for backward compatibility
      const ids = items.map((item) => String(item.id));
      localStorage.setItem("wishlist", JSON.stringify(ids));
    } catch (e) {
      console.error("Error saving wishlist:", e);
    }
  }

  // Fetch product data by handle
  async function fetchProductDataByHandle(handle) {
    try {
      const response = await fetch(`/products/${handle}.json`);
      if (!response.ok) return null;
      const data = await response.json();
      const product = data.product;

      // Ensure we have options_with_values structure
      if (product && !product.options_with_values && product.options) {
        product.options_with_values = product.options.map((opt, idx) => ({
          name: typeof opt === "string" ? opt : opt.name || `Option ${idx + 1}`,
          values: typeof opt === "string" ? [] : opt.values || [],
        }));
      }

      return product;
    } catch (e) {
      console.error("Error fetching product:", e);
      return null;
    }
  }

  // Fetch product data by ID (searches all products)
  async function fetchProductData(productId) {
    try {
      // Try to get handle from data attribute or page
      const productElement = document.querySelector(
        `[data-product-id="${productId}"]`,
      );
      const handle =
        productElement?.getAttribute("data-product-handle") ||
        productElement
          ?.closest("[data-product-handle]")
          ?.getAttribute("data-product-handle");

      if (handle) {
        return await fetchProductDataByHandle(handle);
      }

      // Fallback: try to find in products.json
      const response = await fetch("/products.json?limit=250");
      if (response.ok) {
        const data = await response.json();
        const product = data.products.find(
          (p) => String(p.id) === String(productId),
        );
        if (product) {
          // Ensure options_with_values structure
          if (!product.options_with_values && product.options) {
            product.options_with_values = product.options.map((opt, idx) => ({
              name:
                typeof opt === "string" ? opt : opt.name || `Option ${idx + 1}`,
              values: typeof opt === "string" ? [] : opt.values || [],
            }));
          }
          // Normalize images
          if (product.images && product.images.length > 0) {
            product.images = product.images.map((img) => {
              if (typeof img === "string") {
                return { src: img, url: img };
              }
              return {
                src: img.src || img.url || "",
                url: img.url || img.src || "",
                alt: img.alt || product.title || "",
              };
            });
          }
        }
        return product || null;
      }
      return null;
    } catch (e) {
      console.error("Error fetching product:", e);
      return null;
    }
  }

  // Get product data from page (if on product page)
  function getProductDataFromPage() {
    const productJson = document.getElementById("ProductJson");
    if (productJson) {
      try {
        return JSON.parse(productJson.textContent);
      } catch (e) {
        console.error("Error parsing product JSON:", e);
      }
    }
    return null;
  }

  // Check if product is in wishlist
  function isInWishlist(productId) {
    const wishlist = getWishlist();
    return wishlist.some((item) => String(item.id) === String(productId));
  }

  // Add product to wishlist
  async function addToWishlist(productId, productData = null) {
    const wishlist = getWishlist();

    // Check if already in wishlist
    if (isInWishlist(productId)) {
      return;
    }

    // Try to get product data
    let product = productData;
    if (!product) {
      // Check cache first
      if (window.productDataCache && window.productDataCache[productId]) {
        product = window.productDataCache[productId];
      }
    }
    if (!product) {
      product = getProductDataFromPage();
    }
    if (!product) {
      product = await fetchProductData(productId);
    }

    // Extract size options from variants
    let sizeOptions = [];
    let colorOptions = [];

    if (product?.variants && product.variants.length > 0) {
      // Get options from product (Shopify structure)
      let options = product.options_with_values || product.options || [];

      // Normalize options structure
      if (options.length > 0 && typeof options[0] === "string") {
        // If options is just an array of strings, convert to objects
        options = options.map((opt, idx) => {
          // Try to get values from variants
          const values = new Set();
          product.variants.forEach((v) => {
            const val =
              v.options && v.options[idx]
                ? v.options[idx]
                : idx === 0
                  ? v.option1
                  : idx === 1
                    ? v.option2
                    : v.option3;
            if (val) values.add(val);
          });
          return {
            name: opt,
            values: Array.from(values),
          };
        });
      }

      // Find which option is Size
      let sizeOptionIndex = -1;
      let colorOptionIndex = -1;

      options.forEach((opt, idx) => {
        const optName = (
          typeof opt === "string" ? opt : opt.name || ""
        ).toLowerCase();
        if (optName === "size" || optName.includes("size")) {
          sizeOptionIndex = idx;
        }
        if (optName === "color" || optName === "colour") {
          colorOptionIndex = idx;
        }
      });

      // Extract unique sizes from variants
      if (sizeOptionIndex >= 0) {
        const sizeSet = new Set();
        product.variants.forEach((variant) => {
          let sizeValue = null;
          if (variant.options && variant.options[sizeOptionIndex]) {
            sizeValue = variant.options[sizeOptionIndex];
          } else if (sizeOptionIndex === 0) {
            sizeValue = variant.option1;
          } else if (sizeOptionIndex === 1) {
            sizeValue = variant.option2;
          } else if (sizeOptionIndex === 2) {
            sizeValue = variant.option3;
          }
          if (sizeValue && sizeValue.toLowerCase() !== "default title") {
            sizeSet.add(sizeValue);
          }
        });
        sizeOptions = Array.from(sizeSet).sort();
      } else {
        // Fallback: if no size option found, try to extract from option1, option2, option3
        // This handles cases where size might be in any option position
        const allOptions = new Set();
        product.variants.forEach((variant) => {
          [variant.option1, variant.option2, variant.option3].forEach((opt) => {
            if (opt && opt.toLowerCase() !== "default title") {
              allOptions.add(opt);
            }
          });
        });
        // If we have a reasonable number of options (likely sizes), use them
        if (allOptions.size > 0 && allOptions.size <= 10) {
          sizeOptions = Array.from(allOptions).sort();
        }
      }

      // Extract unique colors from variants
      if (colorOptionIndex >= 0) {
        const colorSet = new Set();
        product.variants.forEach((variant) => {
          const colorValue =
            variant.options && variant.options[colorOptionIndex]
              ? variant.options[colorOptionIndex]
              : colorOptionIndex === 0
                ? variant.option1
                : colorOptionIndex === 1
                  ? variant.option2
                  : variant.option3;
          if (colorValue && colorValue.toLowerCase() !== "default title") {
            colorSet.add(colorValue);
          }
        });
        colorOptions = Array.from(colorSet).map((color) => ({
          name: color,
          value: color,
        }));
      }
    }

    // Normalize images - ensure full URLs
    let normalizedImages = [];

    // Helper to convert relative URLs to absolute
    function normalizeImageUrl(url) {
      if (!url) return "";
      if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
      }
      if (url.startsWith("//")) {
        return "https:" + url;
      }
      if (url.startsWith("/")) {
        return window.location.origin + url;
      }
      return url;
    }

    if (product?.images && product.images.length > 0) {
      normalizedImages = product.images.map((img) => {
        let imgUrl = "";
        if (typeof img === "string") {
          imgUrl = img;
        } else {
          imgUrl = img.src || img.url || "";
        }
        const normalizedUrl = normalizeImageUrl(imgUrl);
        return {
          src: normalizedUrl,
          url: normalizedUrl,
          alt: (typeof img === "object" ? img.alt : "") || product?.title || "",
        };
      });
    } else if (product?.featured_image) {
      const featuredImg = product.featured_image;
      let imgUrl =
        typeof featuredImg === "string"
          ? featuredImg
          : featuredImg.src || featuredImg.url || "";
      const normalizedUrl = normalizeImageUrl(imgUrl);
      normalizedImages = [
        {
          src: normalizedUrl,
          url: normalizedUrl,
          alt: product?.title || "",
        },
      ];
    }

    // Extract price correctly - ensure it's in cents
    let price = 0;
    let salePrice = null;

    if (product?.variants && product.variants.length > 0) {
      const firstVariant = product.variants[0];
      // Shopify prices are always in cents in JSON API
      // Ensure we're getting the raw price value, not a formatted string
      if (firstVariant.price !== undefined && firstVariant.price !== null) {
        price =
          typeof firstVariant.price === "number"
            ? firstVariant.price
            : parseInt(String(firstVariant.price), 10) || 0;
      }
      if (
        firstVariant.compare_at_price !== undefined &&
        firstVariant.compare_at_price !== null
      ) {
        salePrice =
          typeof firstVariant.compare_at_price === "number"
            ? firstVariant.compare_at_price
            : parseInt(String(firstVariant.compare_at_price), 10) || null;
      }
    } else if (product?.price !== undefined && product?.price !== null) {
      // Fallback: if no variants, try product.price
      // Shopify JSON API always uses cents
      price =
        typeof product.price === "number"
          ? product.price
          : parseInt(String(product.price), 10) || 0;
      if (
        product.compare_at_price !== undefined &&
        product.compare_at_price !== null
      ) {
        salePrice =
          typeof product.compare_at_price === "number"
            ? product.compare_at_price
            : parseInt(String(product.compare_at_price), 10) || null;
      }
    }

    // Debug logging (can be removed in production)
    if (price > 0 && price < 1000) {
      console.warn(
        "Wishlist: Price seems low:",
        price,
        "cents for product:",
        product?.title,
        "- Expected price in cents (e.g., 50000 for $500)",
      );
    }

    // Create wishlist item
    const wishlistItem = {
      id: String(productId),
      name: product?.title || "Product",
      handle: product?.handle || "",
      url: product ? `/products/${product.handle}` : "",
      price: price, // Price in cents (Shopify format)
      salePrice: salePrice, // Compare price in cents
      images: normalizedImages,
      variants: product?.variants || [],
      options: product?.options || product?.options_with_values || [],
      colorDetails: colorOptions.length > 0 ? colorOptions : [],
      sizeDetails: sizeOptions,
      size: "",
    };

    wishlist.push(wishlistItem);
    saveWishlist(wishlist);
    updateWishlistCount();
  }

  // Remove product from wishlist
  function removeFromWishlist(productId) {
    const wishlist = getWishlist();
    const filtered = wishlist.filter(
      (item) => String(item.id) !== String(productId),
    );
    saveWishlist(filtered);
    updateWishlistCount();
  }

  // Update wishlist count in header
  function updateWishlistCount() {
    const wishlist = getWishlist();
    const count = wishlist.length;
    const countElements = document.querySelectorAll("[data-wishlist-count]");
    countElements.forEach((el) => {
      el.textContent = count;
      el.setAttribute("data-count", count);
      if (count === 0) {
        el.style.display = "none";
      } else {
        el.style.display = "flex";
      }
    });
  }

  // Make updateWishlistCount available globally
  window.updateWishlistCount = updateWishlistCount;

  // Update wishlist button state
  function updateWishlistButton(button, productId) {
    const isInList = isInWishlist(productId);
    if (isInList) {
      button.classList.add("is-active");
      const svg = button.querySelector("svg");
      if (svg) {
        svg.setAttribute("fill", "#000000");
        svg.setAttribute("stroke", "#000000");
      }
    } else {
      button.classList.remove("is-active");
      const svg = button.querySelector("svg");
      if (svg) {
        svg.setAttribute("fill", "none");
        svg.setAttribute("stroke", "currentColor");
      }
    }
  }

  // Initialize all wishlist buttons on page
  function initWishlistButtons() {
    const wishlistButtons = document.querySelectorAll(
      "[data-wishlist-add], [data-wishlist-action], [data-wishlist-toggle]",
    );
    wishlistButtons.forEach((button) => {
      const productId =
        button.getAttribute("data-wishlist-add") ||
        button.getAttribute("data-product-id") ||
        button.closest("[data-product-id]")?.getAttribute("data-product-id");

      if (productId) {
        updateWishlistButton(button, productId);
      }
    });
  }

  // Handle wishlist button clicks
  document.addEventListener("click", async function (e) {
    const wishlistBtn = e.target.closest(
      "[data-wishlist-add], [data-wishlist-action], [data-wishlist-toggle]",
    );
    if (!wishlistBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const productId =
      wishlistBtn.getAttribute("data-wishlist-add") ||
      wishlistBtn.getAttribute("data-product-id") ||
      wishlistBtn.closest("[data-product-id]")?.getAttribute("data-product-id");

    if (!productId) {
      console.warn("Product ID not found for wishlist button");
      return;
    }

    if (isInWishlist(productId)) {
      removeFromWishlist(productId);
      console.log("Removed from wishlist:", productId);
    } else {
      await addToWishlist(productId);
      console.log("Added to wishlist:", productId);
    }

    // Update wishlist count in header
    updateWishlistCount();

    // Update all wishlist buttons for this product
    const allButtons = document.querySelectorAll(
      `[data-wishlist-add="${productId}"], [data-product-id="${productId}"][data-wishlist-action], [data-product-id="${productId}"][data-wishlist-toggle]`,
    );
    allButtons.forEach((btn) => updateWishlistButton(btn, productId));
  });

  // Initialize buttons on page load
  initWishlistButtons();
  updateWishlistCount();

  // Listen for storage changes (for cross-tab updates)
  window.addEventListener("storage", function (e) {
    if (e.key === "wishlist-storage") {
      updateWishlistCount();
      initWishlistButtons();
    }
  });

  // Re-initialize when new content is loaded (for dynamic content)
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        initWishlistButtons();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

/* FAQ Accordion */
function initFAQ() {
  const faqSections = document.querySelectorAll(".faq-section");
  if (!faqSections.length) return;

  faqSections.forEach((faqSection) => {
    const faqQuestions = faqSection.querySelectorAll("[data-faq-toggle]");
    if (!faqQuestions.length) return;

    faqQuestions.forEach((question) => {
      if (question.dataset.faqInitialized === "true") return;
      question.dataset.faqInitialized = "true";

      question.addEventListener("click", function (e) {
        e.preventDefault();

        const clickedItem = this.closest(".faq-section__item");
        if (!clickedItem) return;

        const clickedAnswer = clickedItem.querySelector(".faq-section__answer");
        const isExpanded = this.getAttribute("aria-expanded") === "true";

        faqQuestions.forEach((otherQuestion) => {
          if (otherQuestion !== this) {
            const otherItem = otherQuestion.closest(".faq-section__item");
            const otherAnswer = otherItem
              ? otherItem.querySelector(".faq-section__answer")
              : null;

            otherQuestion.setAttribute("aria-expanded", "false");

            if (otherItem) {
              otherItem.classList.remove("faq-section__item--active");
            }

            if (otherAnswer) {
              otherAnswer.style.maxHeight = "0";
              otherAnswer.style.opacity = "0";
              otherAnswer.style.visibility = "hidden";
            }
          }
        });

        if (isExpanded) {
          this.setAttribute("aria-expanded", "false");
          clickedItem.classList.remove("faq-section__item--active");

          if (clickedAnswer) {
            clickedAnswer.style.maxHeight = "0";
            clickedAnswer.style.opacity = "0";
            clickedAnswer.style.visibility = "hidden";
          }
        } else {
          this.setAttribute("aria-expanded", "true");
          clickedItem.classList.add("faq-section__item--active");

          if (clickedAnswer) {
            clickedAnswer.style.maxHeight = `${clickedAnswer.scrollHeight}px`;
            clickedAnswer.style.opacity = "1";
            clickedAnswer.style.visibility = "visible";
          }
        }
      });
    });
  });
}

/* Navigation Loading Overlay */
function initNavigationOverlay() {
  // Create overlay element
  const overlay = document.createElement("div");
  overlay.className = "navigation-overlay";
  overlay.innerHTML = `
      <div class="navigation-spinner">
        <div class="navigation-spinner__circle"></div>
      </div>
    `;
  document.body.appendChild(overlay);

  // Show overlay on navigation
  document.addEventListener("click", function (e) {
    const link = e.target.closest("a[href]");
    if (
      link &&
      !link.href.includes("#") &&
      !link.href.includes("javascript:") &&
      !link.target &&
      !e.ctrlKey &&
      !e.metaKey
    ) {
      const hasMegaMenu = link.closest(".site-header__nav-item--has-mega-menu");
      if (!hasMegaMenu) {
        overlay.classList.add("is-visible");
      }
    }
  });

  // Hide overlay on page load
  window.addEventListener("pageshow", function () {
    overlay.classList.remove("is-visible");
  });
}

/* Section Carousel (Premium Materials, Tailored Fit, USA Fulfillment) */
function initSectionCarousel() {
  // Slide data from the provided code
  const slides = [
    {
      id: 1,
      title: "UNMATCHED CRAFTSMANSHIP",
      description:
        "Hours of artisan detail go into every jacket. From reinforced stitching to premium hardware, we build jackets that stand the test of time.",
      features: [
        "Reinforced stitching techniques",
        "Premium YKK zippers",
        "Quality lining materials",
        "Artisan-level attention to detail",
      ],
      imageUrl:
        "https://cdn.shopify.com/s/files/1/0740/5777/7307/files/craftmanship_banner.webp?v=1767897941",
    },
    {
      id: 2,
      title: "PREMIUM MATERIALS",
      description:
        "We don't mass-produce. We craft. Every FINEYST jacket starts with ethically sourced full-grain leather, precision cuts, and hours of artisan detail.",
      features: [
        "Ethically sourced full-grain leather",
        "Premium lambskin and suede options",
        "Distressed finishes for authentic look",
        "Quality tested for durability",
      ],
      imageUrl:
        "https://cdn.shopify.com/s/files/1/0740/5777/7307/files/premium-materials-banner.webp?v=1767897940",
    },
    {
      id: 3,
      title: "TAILORED FIT",
      description:
        "Whether you're buying a ready-to-wear bomber or designing a custom jacket from scratch, you're investing in precision-crafted fit.",
      features: [
        "Standard sizes available",
        "Made-to-measure options",
        "Perfect fit guarantee",
        "Custom sizing consultations",
      ],
      imageUrl:
        "https://cdn.shopify.com/s/files/1/0740/5777/7307/files/Tailored_fit_section.webp?v=1767897940",
    },
    {
      id: 4,
      title: "USA FULFILLMENT",
      description:
        "Fast, reliable shipping with a clear 30-day return policy. Customer pays return shipping unless item is defective. We stand behind every jacket we make with comprehensive customer support.",
      features: [
        "Free shipping",
        "14-day easy returns",
        "Dedicated customer support",
      ],
      imageUrl:
        "https://cdn.shopify.com/s/files/1/0740/5777/7307/files/usa_fulfillment_banner.webp?v=1767897940",
    },
  ];

  let currentIndex = 0;

  // Update all sections with slide content
  function updateAllSections(slide) {
    // Update titles
    const titles = document.querySelectorAll(".slider-content-title");
    titles.forEach((title) => {
      title.textContent = slide.title;
    });

    // Update descriptions
    const descriptions = document.querySelectorAll(
      ".slider-content-description",
    );
    descriptions.forEach((desc) => {
      desc.textContent = slide.description;
    });

    // Update features
    const featuresLists = document.querySelectorAll(".slider-content-features");
    featuresLists.forEach((list) => {
      const existingItems = list.querySelectorAll("li");
      const firstItem = existingItems[0];
      const baseClassName = firstItem ? firstItem.className : "";

      list.innerHTML = "";
      slide.features.forEach((feature) => {
        const listItem = document.createElement("li");
        listItem.className = baseClassName;
        listItem.textContent = feature;
        list.appendChild(listItem);
      });
    });

    // Update images
    const images = document.querySelectorAll(".slider-content-image");
    images.forEach((img) => {
      if (img.tagName === "IMG") {
        img.src = slide.imageUrl;
        img.alt = slide.title;
      }
    });
  }

  // Update pagination dots
  function updatePagination(index) {
    const allDots = document.querySelectorAll(".section-carousel-dot");
    allDots.forEach((dot) => {
      const dotIndex = parseInt(dot.getAttribute("data-index") || "0", 10);
      if (dotIndex === index) {
        dot.classList.add("active");
      } else {
        dot.classList.remove("active");
      }
    });

    // Add class to body to track current slide for CSS targeting
    document.body.classList.remove(
      "carousel-slide-0",
      "carousel-slide-1",
      "carousel-slide-2",
      "carousel-slide-3",
    );
    document.body.classList.add("carousel-slide-" + index);
  }

  // Navigation handlers
  function handlePrev() {
    currentIndex = currentIndex > 0 ? currentIndex - 1 : slides.length - 1;
    updateAllSections(slides[currentIndex]);
    updatePagination(currentIndex);
  }

  function handleNext() {
    currentIndex = currentIndex < slides.length - 1 ? currentIndex + 1 : 0;
    updateAllSections(slides[currentIndex]);
    updatePagination(currentIndex);
  }

  function goToSlide(index) {
    if (index >= 0 && index < slides.length) {
      currentIndex = index;
      updateAllSections(slides[currentIndex]);
      updatePagination(currentIndex);
    }
  }

  // Attach event listeners using event delegation
  document.addEventListener("click", function (e) {
    const prevBtn = e.target.closest(".section-carousel-prev");
    const nextBtn = e.target.closest(".section-carousel-next");
    const dot = e.target.closest(".section-carousel-dot");

    if (prevBtn) {
      e.preventDefault();
      e.stopPropagation();
      handlePrev();
    } else if (nextBtn) {
      e.preventDefault();
      e.stopPropagation();
      handleNext();
    } else if (dot) {
      e.preventDefault();
      e.stopPropagation();
      const dotIndex = parseInt(dot.getAttribute("data-index") || "0", 10);
      goToSlide(dotIndex);
    }
  });

  // Initialize with first slide
  updateAllSections(slides[currentIndex]);
  updatePagination(currentIndex);
}
